import { throttle } from "lodash";
import React, { useEffect, useRef, useState } from "react";
// import { getMemberhipPlans } from "../../../components/search-filter/helper/api";
import FlatPicker from 'flatpickr';
import { closeEnquiry } from "../../features/enquiry/helper/api";
import { getMembershipPlanCount, getMembershipPlans } from "../../features/membership-plans/helper/api";
import { isAuthenticated } from "../../auth";
import { config } from "dotenv";
import Toast from "../../lib/toast";
import { getTaxes } from "../../core/helper/TaxApiCall";
import { formatDate, formatDateTime,startLoader, stopLoader } from "../../lib/utils";
import { getUsersList, getUsersListV2 } from "../../features/employees/helper/api";
import './style.scss';
import { assignNewMemberships, getMemberByBranchPhone } from "../../features/member/helper/api";
import dayjs from 'dayjs'
import { getCustomers } from "../search-filter/helper/api";
import RazorPayLogo from "../../assets/razorpay-icon.png";
import { generatePaymentLink, getPaymentConfirmation } from "../../features/memberships/helper/api";
import { getBranchConfig } from './helper/index';


let flatpickr;
let timer;

const MembershipBillingController = (props) => {

  const [amountPaid,setAmountPaid] = useState(0);
  const [isUserDetailsOpen, setUserDetailsOpen] = useState(true);
  const [currentElementId, setCurrentElementId] = useState("");
  const pageSize = 1000;
  var [pageNo,setPageNo] = useState(1);
  // const [isApplyTaxes,setApplyTaxes] = useState(false);
  const [pageCount,setPageCount] = useState(0);
  const [total,setTotal] = useState(0);
  const [isRemainingAmountDue, setRemainingAmountDue] = useState(false);
  const [membershipBillingConfig, setMembershipBillingConfig] = useState("");
  
  const [handlerSearchKey, setHandlerSearchKey] = useState("");
  const [trainerSearchKey, setTrainerSearchKey] = useState("");
  const [closeEnqDetails, setCloseEnqDetails] = useState({
    emergencyContactName: "",
    emergencyContactNumber: "",
    paymentDueDate:'',
    panNumber: "",
    aadharNumber: "",
    gstinNumber: "",
    invoiceDate: new Date(),
    billingDate: new Date(),
    membership: "",
    selectedMemberships: [],
    membershipDiscount: "",
    selectedTrainer: "",
    selectedHandler: "",
    date: new Date(),
    surCharges: "",
    amountPaid: "",
    paidDiscount: "",
    paymentMode: "Online",
    paymentSource: "",
    paymentNumber: "",
    chequeNumber: "",
    cardType: "",
    bankName: "",
    upiId: "",
    comment: "",
    approvedCode: "",
    transactionID: "",
  });
  const [selectedMembershipPackage, setSelectedMembershipPackage] = useState(0);


  const [taxes, setTaxes] = useState([]); // server taxes

  const [billingInfo, setBillingInfo] = useState({
    GstOnPaidAmount: false,
    selectedPlansPrice: 0,
    selectedPlansDiscount: 0,
    baseAmount:0,
    taxableAmount:0,
    subTotal: 0,
    poolCharge: 0,
    surCharges: 0,
    taxBreakup: [],   // CGST, SGST, etc
    totalTax: 0,
    transactionID: "",
    payableAmount: 0,
    remainingAmount: 0
  });
  const membershipTypes = ["GymWorkout", "PersonalTraining", "GroupEx", "LybertyMembership", "Package", "Campaign"];
  const [selectedMembershipType, setSelectedMembershipType] = useState("GymWorkout");
  const [taxType,setTaxType] = useState('');
  const [allMemberships, setAllMemberships] = useState([]);
  const [trainersList, setTrainersList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isPaymentModeOpen, setPaymentModeOpen] = useState(false);
  const paymentModes = ["Online", "Razorpay", "Card", "Cheque", "Cash", "Wallet", "Other"];
  const [paymentSources, setPaymentSources] = useState({
    // "Credit Card", "Debit Card"
    online: ["NEFT", "RTGS", "IMPS", "UPI"],
    wallet: ["Paytm", "PhonePe", "Google Pay", "Amazon Pay"]
  });
  const [cardTypes, setCardTypes] = useState(["Visa", "Mastercard", "Zeta", "Rupay", "Amex", "Bajaj Finserv", "Tata Card"]);
  const [currentSource, setCurrentSource] = useState("");
  const [isButtonLock, setButtonLock] = useState(false);
  const [isMemberShipSpinnerLoader,setMemberShipSpinnerLoader] = useState(false);
  const [isEditBillingInfoSubTotal, setEditBillingInfoSubTotal] = useState(false);
  const [editableSubTotal, setEditableSubTotal] = useState("");
  const [membershipEditIndex, setMembershipEditIndex] = useState(-1);
  const [tempMembershipDate, setTempMembershipDate] = useState("");
  const [selectedPoolMembership, setSelectedPoolMembership] = useState(null);
  const [isAddNewMemberOpen, setAddNewMemberOpen] = useState(false);
  const [newMember, setNewMember] = useState({
    name: "",
    phone: ""
  });
  const [isMemberExistingNote, setMemberExistingNote] = useState(false);
  const [isMemberListOpen, setMemberListOpen] = useState(false);
  const [allowPoolMembership, setAllowPoolMembership] = useState(false);
  const [editDateType, setEditDateType] = useState("");

  //Customer
  const [customerPageNo, setCustomerPageNo] = useState(1);
  const [customerPageSize,setCustomerPageSize] = useState(10);
  const [customerPageCount, setCustomerPageCount] = useState(1);
  const [customerTotal, setCustomerTotal] = useState(0);
  const [customerSearchKey, setCustomerSearchKey] = useState("");
  const [isCustomerSpinnerLoader,setCustomerSpinnerLoader] = useState(false)
  const [customers, getAllCustomers] = useState([]);
  const [hasMore,setHasMore] = useState(false);
  const [razorpayInfo, setRazorpayInfo] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const intervalRef = useRef(null);


  const {user,token} = isAuthenticated();



  const GetCustomerParam = () =>{
    let param = {
      pageNo:customerPageNo,
      pageSize:customerPageSize
    };
    if(customerSearchKey) param.q = customerSearchKey;
    param.branchId = localStorage.getItem("branchId");

    return param;
  }

  const GetAllCustomer = async (isReload) =>{
    try{
      const param = GetCustomerParam();
      let response = await getCustomers(user._id,token,param);

      if(!response.error){

        await Promise.all(response.data.map(data=>{
          if(data.isEnquiry && !data?.user?.length){
            data.user = [
              {
                name:data?.userInfo?.name  || data?.userInfo?.full_name,
                phone:data?.userInfo?.phone,
                email:data?.userInfo?.name
              }
            ]
          }
        }))

        getAllCustomers(isReload?response.data:[...customers,...response.data]);
        setHasMore(response?.pagination?.hasMore?true:false);
        setCustomerTotal(response.pagination.totalRecords);
      }
    }catch(error){

    }
  }

  const selectMemberShipType = plan => e =>{
    setCloseEnqDetails(oldstate=>{
      oldstate.membership = "";
      oldstate.selectedTrainer = "";

      return {
        ...oldstate
      }
    })
    setSelectedMembershipType(plan);
    e.stopPropagation()
  }

  const applyInclusive = () =>{
    if(taxType == "inclusive-tax") setTaxType("")
    else setTaxType("inclusive-tax")
  }


  const cancelCloseEnquiry=event=>{
    setRemainingAmountDue(false)
  }

  const checkAndCloseEnquiry = event =>{
    if(billingInfo.remainingAmount>0){
      setRemainingAmountDue(true);
    }else{
      CloseEnquiry();
    }
  }

  const CloseEnquiry = async () => {
     if (billingInfo.remainingAmount > 0 && !closeEnqDetails.paymentDueDate) {
    new Toast({
      type: 'error',
      message: "Please select Payment Due Date",
      duration: 3000
    });
    return;
  }
    try{

      startLoader()
      setButtonLock(true);

      const payload = {
        emergencyContactName: closeEnqDetails.emergencyContactName,
        emergencyContactNumber: closeEnqDetails.emergencyContactNumber,
        paymentDueDate: billingInfo.remainingAmount > 0 ? closeEnqDetails.paymentDueDate : undefined,
        panNumber: closeEnqDetails.panNumber,
        aadharNumber: closeEnqDetails.aadharNumber,
        gstinNumber: closeEnqDetails.gstinNumber,
        invoiceDate: closeEnqDetails.invoiceDate,
        paymentDate: closeEnqDetails.billingDate,

        trainerId: closeEnqDetails.selectedTrainer._id,
        handledById: closeEnqDetails.selectedHandler._id,

        date: props.type == "upgrade-membership" ? props.selectedUsers.starts_at : closeEnqDetails.date,
        surCharges: closeEnqDetails.surCharges,
        amountPaid: billingInfo.GstOnPaidAmount ? billingInfo.payableAmount : closeEnqDetails.amountPaid,
        paymentMode: closeEnqDetails.paymentMode,
        paymentSource: closeEnqDetails.paymentSource,
        chequeNumber: closeEnqDetails.chequeNumber,
        bankName: closeEnqDetails.bankName,
        upiId: closeEnqDetails.upiId,
        comment: closeEnqDetails.comment,
        approvedCode: closeEnqDetails.approvedCode,
        paymentNumber: closeEnqDetails.paymentNumber,
        cardType: closeEnqDetails.cardType,
        transactionID: closeEnqDetails.transactionID,
        globalComment:closeEnqDetails.globalComment,

        // membershipplanId: closeEnqDetails.membership._id,
        // membershipDiscount: closeEnqDetails.membership.packages[0].discount
        // basePrice:closeEnqDetails.membership.packages[0].basePrice,
        // rackRate:closeEnqDetails.membership.packages[0].rackRate,
        // duration:closeEnqDetails.membership.packages[0].duration,
        // duration_unit:closeEnqDetails.membership.packages[0].durationType,
        // packageSession:closeEnqDetails.membership.packages[0].sessions,
        // packageId:closeEnqDetails.membership?.packages[0]?._id,

        selectedMemberships: closeEnqDetails.selectedMemberships,

        taxIDs:taxes.map(d=>d._id),
        gstOnPaidAmount: billingInfo.GstOnPaidAmount == true && billingInfo.GstOnPaidAmount,
        poolCharge: billingInfo.poolCharge,
        plansPrice: billingInfo.selectedPlansPrice,
        paidDiscount: parseFloat(closeEnqDetails.paidDiscount || 0),
        discount: billingInfo.GstOnPaidAmount ? parseFloat(closeEnqDetails.paidDiscount || 0) : billingInfo.selectedPlansDiscount,
        subTotal:billingInfo.subTotal,
        surCharges: billingInfo.surCharges,
        totalTax: billingInfo.totalTax,
        payableAmount: billingInfo.payableAmount,
        remainingAmount: billingInfo.remainingAmount,
        baseAmount:billingInfo.baseAmount,
        taxType,
        //sale_type:props.type == "upgrade-membership"?'UPGRADE':props.type == "renew-membership"?'RENEW':props.type == 'FRESH_SALE'?'FRESH_SALE':'NEWSALE',
        closed_by_role:user.role
      };

      if (paymentStatus != null) {
        payload.razorpayPayment = "true";

        payload.razorPay = {
          razorpayPaymentLinkId: paymentStatus.razorPay.razorpayPaymentLinkId,
          razorpayPaymentId: paymentStatus.razorPay.razorpayPaymentId || null,
          razorpayOrderId: paymentStatus.razorPay.razorpayOrderId || null,

          razorpayAmountPaid: paymentStatus.razorPay.razorpayAmountPaid || 0,
          razorpayMethod: paymentStatus.razorPay.razorpayMethod || null,

          razorpayStatus:
            paymentStatus.razorPay.razorpayStatus ||
            paymentStatus.razorPay.status ||
            'created',

          razorpayShortUrl: paymentStatus.razorPay.razorpayShortUrl || null,

          razorpayPaidAt: paymentStatus.razorPay.razorpayPaidAt || null,
          razorpayRrn: paymentStatus.razorPay.razorpayRrn || null,

          webhookReceived: false
        };
      }

      if(props.type == "upgrade-membership"){
        payload.sale_type = 'UPGRADE'
      }else if(props.activeMemberships && props.activeMemberships.length > 0){

        if(selectedMembershipType == "PersonalTraining"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "PersonalTraining"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }

        if(selectedMembershipType == "GymWorkout"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "GymWorkout"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }

        if(selectedMembershipType == "GroupEx"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "GroupEx"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }

        if(selectedMembershipType == "LybertyMembership"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "LybertyMembership"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }

        if(selectedMembershipType == "Package"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "Package"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }

        if(selectedMembershipType == "Campaign"){
          const activeMembership = props.activeMemberships.filter(membership => membership.membershipplans?.some(plan => plan.type === "Campaign"));
          if(activeMembership.length > 0){
            payload.sale_type = 'NEWSALE'
          }else{
            payload.sale_type = 'RENEW'
          }
        }
      }else if(props.type == 'NEWSALE'){
        payload.sale_type = 'NEWSALE'
      }else{
        payload.sale_type = 'FRESH_SALE'
      }

      if(props.type == "upgrade-membership"){
        payload.upgradedMemberShipId = props.selectedUsers._id;
      }

      if(payload.sale_type != "FRESH_SALE"){
        payload.memberId = props.selectedUsers._id;
        payload.branchId = props.selectedUsers.branchId;
        payload.userInfo = {
          ...(props?.selectedUsers?.userInfo || {})
        }
      }

      // alert(payload.sale_type + " API called");
      // console.log(payload);

      // return null;

      const response = (payload.sale_type == "NEWSALE" || payload.sale_type == "UPGRADE" || payload.sale_type == 'RENEW')?await assignNewMemberships(user._id,token,payload):await closeEnquiry(user._id,token,props.selectedUsers._id,payload);

      console.log("response received:", response);
      console.log("response.error:", response.error);

     if(response && !response.error){
        new Toast({
          type:'success',
          message:"Enquiry closed successfully",
          duration:3000
        });

        if(typeof props.handleCreatedMembershipId === "function"){
          props.handleCreatedMembershipId(response?.membership?._id);
        }

        if(typeof props.reload == "function"){
          props.reload();
        }

        if(typeof props.handleCloseModal == "function"){
          props.handleCloseModal();
        }

      }else{
        new Toast({
          type:'error',
          message:"Error closing the enquiry",
          duration:3000
        })
      }

    }catch(error){
      console.error("CloseEnquiry crash:", error);   
      new Toast({
        type:'error',
        message:"Something went wrong",
        duration:3000
      })
    }

    stopLoader();
    setButtonLock(false);
  }

  const applyTaxes = event =>{
    if(taxType == "additional-tax") setTaxType("")
    else setTaxType('additional-tax');
  }


  const GetAllTaxes = async () =>{
    try{
      const branchId = localStorage.getItem("branchId");
      const params = {
        branchId
      };
      const responses = await getTaxes(user._id,token,params);

      if(!responses.error){
        setTaxes(responses);
      }
    }catch(error){

    }
  }

  const GetUserParams = (req,res) =>{
    const branchId = props?.selectedUsers?.branchId || localStorage.getItem("branchId");
    const params = {
      noLimit:'noLimit',
      branchIDs:[branchId],
      isAllUser:true,
      roles:[5,6,7,10,2]
    };

    return params;
  }

  const GetAllUser = async () =>{
    try{
      const params = GetUserParams();
      const response = await getUsersListV2(user._id,token,params);
      if(response.error){
      }else{
        setTrainersList(response)
      }
    }catch(error){
    }
  }

  const GetAllEmployeeParams = (req,res) =>{
    const branchId = props?.selectedUsers?.branchId || localStorage.getItem("branchId");
    const params = {
      noLimit:'noLimit',
      branchIDs:[branchId],
      isAllUser:true,
    };

    return params;
  }

  const GetAllEmployees = async () =>{
    try{
      const params = GetAllEmployeeParams();
      const response = await getUsersListV2(user._id,token,params);
      if(response.error){
      }else{
        setEmployeeList(response)
      }
    }catch(error){
    }
  }


  const GetMembershipPlanParams=()=>{
    let params = {
      pageNo:pageNo,
      pageSize:pageSize,
      branchId:localStorage.getItem("branchId")
    };

    params.type = selectedMembershipType;

    if(allowPoolMembership){
      params.poolMembership = "true"
    }

    return params;
  }


  const GetMembershipPlans = async (isReload) =>{
    try{

      const params = GetMembershipPlanParams();

      const response = await getMembershipPlans(user._id,token,params);

      if(response.error){

      }else{
        setAllMemberships(isReload?response:[...allMemberships,...response]);
      }

    }catch(error){
      new Toast({
        type:'error',
        message:error,
        duration:3000
      })
    }
  }

  const handlePaymentMode = paymentMode => event =>{
    try{
      setCloseEnqDetails(oldstate=>{

        oldstate.paymentMode = paymentMode;
        oldstate.paymentSource = "";
        oldstate.chequeNumber = "";
        oldstate.bankName = "";
        oldstate.upiId = "";
        oldstate.comment = "";
        oldstate.transactionID = "";

        return {
          ...oldstate
        }
      })
    }catch(error){

    }
  }


   const GetMembershipPlanCount = async () =>{
     try{

      const params = GetMembershipPlanParams();
      delete params.pageNo;
      delete params.pageSize;

      const response = await getMembershipPlanCount(user._id,token,params);

      if(response.error){

      }else{
        pageNo = 1;
        setPageNo(pageNo)
        setPageCount(Math.ceil(response.COUNT / pageSize))
        setTotal(response.COUNT)
      }

    }catch(error){
      new Toast({
        type:'error',
        message:error,
        duration:3000
      })
    }
   }


  const toggleUserDetails = () => {
    setUserDetailsOpen(!isUserDetailsOpen)
  }

  const toggleInputFields = (id) => event => {
    if (currentElementId == id) {
      setCurrentElementId('')
    }
    // else if(id == "invoice-date"){
    //   alert("Date change not allowed")
    //   return;
    // }
    else {
      setCurrentElementId(id);

      let element = document.getElementById(id);
      if (element) {
        element.focus();

        if(id == "enq-closing-date" || id == "billing-date" || id == "invoice-date" || id == "payment-due-date"){
          handleSelectDate(id);
        }

      }

    }
  }

  const handleChange = (name, value, membershipId) => event => {
    value = !value ? event.target.value : value;

    if(timer){
      clearTimeout(timer);
      timer = null;
    }

    if(name == "editable-subtotal"){
      setEditableSubTotal(value)
    }

    if(name?.includes("temp-end-date-")){
      handleSelectDate(name)
    }

    if(name?.includes("temp-start-date-")){
      handleSelectDate(name)
    }

    if(name == "membership-end-date"){
      handleSelectDate(name)
    }

    if(name == "member-name"){
      setNewMember(prev => ({
        ...prev,
        name: value
      }))
    }

     if(name == "member-phone"){
      setNewMember(prev => ({
        ...prev,
        phone: value
      }))
    }

    if (name === "membershipDiscount") {
      const rawValue = event.target.value;

      const selectedMembershipIndex = closeEnqDetails.selectedMemberships.findIndex(
        m => m._id === membershipId
      );

      if (selectedMembershipIndex === -1) return;

      const { rackRate = 0, basePrice = 0 } =
        closeEnqDetails.selectedMemberships[selectedMembershipIndex].packages;

      const maxDiscount = rackRate - basePrice;

      setCloseEnqDetails(prev => ({
        ...prev,
        selectedMemberships: prev.selectedMemberships.map((m, i) =>
          i === selectedMembershipIndex
            ? { ...m, membershipDiscount: event.target.value }
            : m
        )
      }));

      clearTimeout(timer);

      timer = setTimeout(() => {
        setCloseEnqDetails(prev => {
          const latestDiscount = parseFloat(
            prev.selectedMemberships[selectedMembershipIndex].membershipDiscount
          ) || 0;  // fallback to 0 if empty/NaN

          if (latestDiscount > maxDiscount) {
            new Toast({
              type: 'info',
              duration: 3000,
              message: "Discount can't exceed the allowed maximum"
            });

            return {
              ...prev,
              selectedMemberships: prev.selectedMemberships.map((m, i) =>
                i === selectedMembershipIndex
                  ? { ...m, membershipDiscount: 0 }
                  : m
              )
            };
          }

          return prev;
        });

        timer = null;
      }, 1000);
    }

    else{
      setCloseEnqDetails({
        ...closeEnqDetails,
        [name]: value
      });

      if (name == "subTotal") {
        timer = setTimeout(() => {
          if (value) {
            const parsedValue = parseFloat(value);

            const totalRackRate = closeEnqDetails.selectedMemberships?.reduce(
              (sum, m) => sum + (m.packages?.rackRate || 0), 0
            );
            const totalBasePrice = closeEnqDetails.selectedMemberships?.reduce(
              (sum, m) => sum + (m.packages?.basePrice || 0), 0
            );

            if (parsedValue < totalBasePrice) {
              new Toast({
                type: 'info',
                duration: 3000,
                message: `Amount Cannot be less than base price of Rs. ${totalBasePrice}`
              });
            } else if (parsedValue > totalRackRate) {
              new Toast({
                type: 'info',
                duration: 3000,
                message: `Amount Cannot be more than Rack Rate of Rs. ${totalRackRate}`
              });
            } else {
              const totalDiscount = totalRackRate - parsedValue;

              setCloseEnqDetails(prev => ({
                ...prev,
                selectedMemberships: prev.selectedMemberships.map((m, i) =>
                  i === 0 ? { ...m, membershipDiscount: totalDiscount } : m
                )
              }));

              setBillingInfo(prev => ({
                ...prev,
                subTotal: Math.round(parsedValue)
              }));

              setEditBillingInfoSubTotal(false);
            }
          }

          clearTimeout(timer);
          timer = null;
        }, 0);
      }

      if(name == "amountPaid"){
        timer = setTimeout(()=>{
          if(value){
            if(billingInfo.GstOnPaidAmount){
                const planTotal = billingInfo.selectedPlansPrice - billingInfo.selectedPlansDiscount + (billingInfo.poolCharge||0);
                // or totalBaseAmount+pool
                if(parseFloat(value) > planTotal){
                  new Toast({type:'info', duration:3000, message:"Paid base can't exceed plan total"});
                  setCloseEnqDetails(s=>({...s, amountPaid: planTotal}));
                }
                // do NOT clamp to payable; payable=base+tax recomputed in effect
              }
            else if((parseFloat(value))>billingInfo.payableAmount){
              new Toast({
                type:'info',
                duration:3000,
                message:"Paid amount can't be more then payable amount"
              })
              setCloseEnqDetails(oldstate=>{
                oldstate['amountPaid'] = billingInfo.payableAmount
                return {
                  ...oldstate
                }
              })
            }
          }

          clearTimeout(timer);
          timer = null;

        },1000);
      }
      if(name == "paidDiscount"){
        timer = setTimeout(()=>{
          const totalRack = closeEnqDetails.selectedMemberships?.reduce((s,m)=>s+(m.packages?.rackRate||0),0);
          const totalBase = closeEnqDetails.selectedMemberships?.reduce((s,m)=>s+(m.packages?.basePrice||0),0);
          const paidBase = parseFloat(closeEnqDetails.amountPaid||0);
          const maxDiscount = paidBase < totalBase ? (totalRack-totalBase) : (totalRack-paidBase);
          const v = parseFloat(value||0);
          if(value && (v<0 || v>maxDiscount)){
            new Toast({type:'info', duration:3000, message:`Discount can be 0 to ₹ ${Math.max(0,Math.round(maxDiscount))}`});
            setCloseEnqDetails(prev=>({...prev, paidDiscount: Math.max(0,Math.round(maxDiscount))}));
          }
          clearTimeout(timer); timer=null;
        },500);
      }
    }
  }


  const handleSelectMembership = (membership, index) => {

    const packageInfo = props.selectedUsers.membershipplans?.[0]?.packages?.filter(d=>d._id == membership.packages?.[index]?._id)

    if(props.type == "upgrade-membership" && membership._id == props.selectedUsers.plan_id && packageInfo[0].sessions == props.selectedUsers.sessions) {
      return new Toast({
        type:'warning',
        message:"This membership is already selected and can't be chosen again.",
        duration:3000
      })
    }

    if(props.type == "upgrade-membership" && Number(membership.packages[index ? index : 0].rackRate) < Number(amountPaid)) {
      return new Toast({
        type:'warning',
        message:"Please choose a membership with an amount equal to or greater than the current one.",
        duration:3000
      })
    }

    // TODO
    console.log("Hello Props", props)
    console.log("Hello Date", closeEnqDetails.date)

    const newEntry = {
      ...membership,
      packages: membership.packages[index?index:0],
      membershipDiscount: 0,
      totalTax:0,
      subTotal:membership.packages[index?index:0].rackRate,
      surCharges:0,
      payableAmount:membership.packages[index?index:0].rackRate,
      baseAmount:membership.packages[index?index:0].rackRate,
      startDate: props.type === "upgrade-membership" && props.selectedUsers.starts_at ? props.selectedUsers.starts_at : closeEnqDetails.date,
      endDate: (() => {
        const pkg = membership.packages[index ? index : 0];
        const startDate = (props.type === "upgrade-membership" && props.selectedUsers.starts_at ?  props.selectedUsers.starts_at : closeEnqDetails.date);
        if (!startDate || !pkg) return null;

        const { duration, durationType } = pkg;

        const type = durationType?.toLowerCase().replace(/s$/, "").replace("(s)", "").trim();

        if (type === "month") {
          const raw = dayjs(startDate).add(duration, "month");
          const isClamped = raw.date() !== dayjs(startDate).date();
          return isClamped ? raw.toISOString() : raw.subtract(1, "day").toISOString();
        } else if (type === "week") {
          return dayjs(startDate).add(duration, "week").subtract(1, "day").toISOString();
        } else if (type === "day") {
          return dayjs(startDate).add(duration, "day").subtract(1, "day").toISOString();
        }

        return null;
      })()
    };

    if(membership.packages[index?index:0].poolMembership == true){
      newEntry.poolMembers = [];
      newEntry.newMembers = [];
      newEntry.poolCharge = 0;
    }

    const currentList = closeEnqDetails.selectedMemberships || [];
    let updatedMembership;

    if (props.type === "upgrade-membership" || allowPoolMembership) {
      const isAlreadySelected =
        currentList.length > 0 &&
        currentList[0]._id == membership._id &&
        currentList[0].packages._id ==
          membership.packages[index ? index : 0]._id;

        updatedMembership = isAlreadySelected ? [] : [newEntry];
    } else {
      const existingIndex = currentList.findIndex(
        m =>
          m._id == membership._id &&
          m.packages._id == membership.packages[index ? index : 0]._id
      );

      updatedMembership =
        existingIndex !== -1
          ? currentList.filter((_, i) => i !== existingIndex)
          : [...currentList, newEntry];
    }

    // const existingIndex = currentList.findIndex(m => m._id == membership._id && m.packages._id == membership.packages[index?index:0]._id);

    // const updatedMembership = existingIndex !== -1
    // ? currentList.filter((_, i) => i !== existingIndex)
    // : [...currentList, newEntry];

    setCloseEnqDetails({
      ...closeEnqDetails,
      selectedMemberships: updatedMembership
    });
  }
  const filteredHandlers = employeeList.filter(handler =>
  `${handler.name || ""}`.toLowerCase().includes(handlerSearchKey.trim().toLowerCase())
  );
  const filteredTrainers = trainersList.filter(trainer =>
    `${trainer.name || ""}`.toLowerCase().includes(trainerSearchKey.trim().toLowerCase())
  );
  const selectTrainer = (trainer) => {
  setCloseEnqDetails({
    ...closeEnqDetails,
    selectedTrainer: trainer
  });
  setTrainerSearchKey("");
  }

  const selectHandler = (employee) => {
  setCloseEnqDetails({
    ...closeEnqDetails,
    selectedHandler: employee
  });
  setHandlerSearchKey("");
  }


  const handleSelectDate = (id) => {
    flatpickr = FlatPicker("#"+id, {
      disableMobile: true,
      defaultDate: id.includes("temp-end-date-") && membershipEditIndex != -1 ? new Date(closeEnqDetails.selectedMemberships[membershipEditIndex].endDate) : id.includes("temp-start-date-") && membershipEditIndex != -1 ? new Date(closeEnqDetails.selectedMemberships[membershipEditIndex].startDate) : id == "membership-end-date" ? new Date(closeEnqDetails.selectedMemberships[0].endDate) : new Date(),
      onChange: (e) => {
        if(e.length>0) {

          // if(new Date(e[0])<new Date(new Date().setHours(0,0,0,0))){
          //   return alert("Please note, selecting a previous date is not allowed. Kindly choose a current or future date");
          // }
          if((id.includes("temp-end-date-") || id.includes("temp-start-date-")) && membershipEditIndex != -1){
            setTempMembershipDate(e[0])
          }else{
            setCloseEnqDetails(oldstate=>{
              if(id == "billing-date") oldstate.billingDate = e[0];
              else if(id == "invoice-date") oldstate.invoiceDate = e[0];
              else if(id == "membership-end-date") {oldstate.selectedMemberships = oldstate.selectedMemberships.map((m, i) => i === 0 ? { ...m, endDate: e[0]}: m)}
              else if(id == "payment-due-date") oldstate.paymentDueDate = e[0];
              else if(id == "enq-closing-date") oldstate.date = e[0];
              else oldstate.date = e[0];
              return {
                ...oldstate
              }
            });
          }
        }
      }
    })
    flatpickr.open();
  }




  const handleSelectPaymentSource = (source) => {
    setCloseEnqDetails((oldState) => ({
      ...oldState,
      paymentSource: source
    }))
  }

  const handleSelectCard = (getCardType) => {
    setCloseEnqDetails((oldState) => ({
      ...oldState,
      cardType: getCardType
    }))
  }

  const toggleEditBillingInfo = (type) => {
    if(type == "check"){
      handleChange("subTotal", editableSubTotal)({
        target: { value: editableSubTotal }
      });
    }else{
      setEditBillingInfoSubTotal(!isEditBillingInfoSubTotal)    }
  }

  const handleEditMembershipDate = (index, dateType) => {
    if(index != membershipEditIndex){
      setMembershipEditIndex(index);
      setEditDateType(dateType);
    }else{
      setMembershipEditIndex(-1);
      setEditDateType("");
    }
  }

  const toggleMembershipDate = (actionType, dateType) => {
    if(actionType == "cancel"){
      setMembershipEditIndex(-1);
      setEditDateType("");
    }else{

      if(dateType == "end"){
        setCloseEnqDetails(prev => ({
          ...prev,
          selectedMemberships: prev.selectedMemberships.map((m, i) =>
            i === membershipEditIndex
              ? { ...m, endDate: tempMembershipDate }
              : m
          )
        }));
      }

      if (dateType == "start") {
        setCloseEnqDetails(prev => ({
          ...prev,
          selectedMemberships: prev.selectedMemberships.map((m, i) => {
            if (i !== membershipEditIndex) return m;

            console.log(m);
          
            const pkg = m.packages;
            console.log("membership item:", m, "resolved pkg:", pkg, "tempMembershipDate:", tempMembershipDate);
            
            const newEndDate = calculateEndDate(tempMembershipDate, pkg);
            console.log("newEndDate:", newEndDate);

            return {
              ...m,
              startDate: tempMembershipDate,
              endDate: newEndDate,
            };
          })
        }));
      }

      
      setMembershipEditIndex(-1);
      setEditDateType("");
    }
  }

  const calculateEndDate = (startDate, pkg) => {
    if (!startDate || !pkg) return null;

    const { duration, durationType } = pkg;
    const type = durationType?.toLowerCase().replace(/s$/, "").replace("(s)", "").trim();

    if (type === "month") {
      const raw = dayjs(startDate).add(duration, "month");
      const isClamped = raw.date() !== dayjs(startDate).date();
      return isClamped ? raw.toISOString() : raw.subtract(1, "day").toISOString();
    } else if (type === "week") {
      return dayjs(startDate).add(duration, "week").subtract(1, "day").toISOString();
    } else if (type === "day") {
      return dayjs(startDate).add(duration, "day").subtract(1, "day").toISOString();
    }

    return null;
  };

  const handleCheckExistingMember = async(membershipInfo) => {

    if(newMember.phone && newMember.name){
      try{
        const params = {
          branchId: localStorage.getItem("branchId"),
          phone: newMember.phone
        };

        const isExistingMember = await getMemberByBranchPhone(user._id, token, params);

        console.log(isExistingMember);

        if(isExistingMember.data){
          setMemberExistingNote(true);
        }else{
          handleAddNewCustomer(membershipInfo);
          setMemberExistingNote(false);
          setAddNewMemberOpen(false);
          setTimeout(() => {
            setNewMember({
              name:"",
              phone:""
            })
          }, 100);
        }

      }catch{

      }
    }else{
      new Toast({
        type:'error',
        duration:3000,
        message: "New Member Phone or Number Cannot be empty"
      })
    }
  }

  const toggleMemberList = (membershipInfo) => {
    if(isMemberListOpen){
      setMemberListOpen(false)
      setSelectedPoolMembership(null)
    }else{
      setMemberListOpen(true)
      setAddNewMemberOpen(false)
      setSelectedPoolMembership(membershipInfo._id)
    }
  }

  const toggleAddNewMember = (membershipInfo) => {
    if(isAddNewMemberOpen){
      setAddNewMemberOpen(false)
      setSelectedPoolMembership(null)
    }else{
      setAddNewMemberOpen(true)
      setMemberListOpen(false)
      setSelectedPoolMembership(membershipInfo._id)
    }
  }

  const handleSearchCustomer = () => event => {
    setCustomerSearchKey(event.target.value)
  }

  const handleSelectPoolMembership = (membership) => {
    setMemberListOpen(true)
    setSelectedPoolMembership(membership._id);
  }

  const handleSelectCustomer = (customerInfo, membershipInfo) => {
    console.log(customerInfo)
    let selectedMembershipIndex = closeEnqDetails.selectedMemberships.findIndex(m => m._id == membershipInfo._id);

    setCloseEnqDetails(prev => ({
      ...prev,
      selectedMemberships: prev.selectedMemberships.map((m, i) =>{
        if (i !== selectedMembershipIndex) return m;

        const exists = m.poolMembers.some(
          p => p._id === customerInfo._id
        );

        return {
          ...m,
          poolMembers:
          exists ? m.poolMembers.filter( p => p._id !== customerInfo._id )
          : [...m.poolMembers, customerInfo]
        }
      })
    }))

    setMemberListOpen(false);
  }

  const handleAddNewCustomer = (membershipInfo, member) => {
    let selectedMembershipIndex = closeEnqDetails.selectedMemberships.findIndex(m => m._id == membershipInfo._id);

    setCloseEnqDetails(prev => ({
      ...prev,
      selectedMemberships: prev.selectedMemberships.map((m, i) =>{
        if (i !== selectedMembershipIndex) return m;

        const exists = m.newMembers.some(
          p => p.phone === (member ? member.phone : newMember.phone)
        );

        console.log(member)
        console.log(exists)

        return {
          ...m,
          newMembers:
          exists ? m.newMembers.filter( p => p.phone !== (member ? member.phone : newMember.phone))
          : [...m.newMembers, newMember]
        }
      })
    }))
  }

  const handleCustomerListScroll = throttle(async (event) => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && hasMore && !isCustomerSpinnerLoader) {
        setCustomerPageNo(prev => prev + 1);
        setCustomerSpinnerLoader(true);
        await GetAllCustomer();
        setCustomerSpinnerLoader(false);
      }
    } catch (error) {
      setCustomerSpinnerLoader(false)
    }
  }, 800);

  const poolMembership = (membershipInfo, index) => {
    return(
      <div className="pool-membership-container" style={{marginBottom:"12px"}}>
        <p className="font-weight-700 color-dark-blue p-b-12">Select - <span className="color-red">Pool Members</span></p>
        {
          (((membershipInfo?.poolMembers?.length || 0)  + (membershipInfo?.newMembers?.length || 0)) < 5) && (
            isAddNewMemberOpen && selectedPoolMembership === membershipInfo._id ? [
              <div className="d-flex p-b-12">
                <div onClick={toggleInputFields('member-name')} className={`${currentElementId == "member-name" || newMember.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: currentElementId == "member-name" || newMember.name ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "26%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <svg className="flex-item m-r-6" width={currentElementId == "member-name" || newMember.name ? "12" : "16"}  height={currentElementId == "member-name" || newMember.name ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 1.07143C6.5439 1.07143 7.07558 1.22852 7.52782 1.52285C7.98005 1.81717 8.33253 2.23551 8.54067 2.72496C8.74881 3.2144 8.80327 3.75297 8.69716 4.27256C8.59105 4.79216 8.32914 5.26943 7.94454 5.64404C7.55995 6.01864 7.06995 6.27375 6.5365 6.3771C6.00305 6.48046 5.45012 6.42741 4.94762 6.22468C4.44512 6.02194 4.01563 5.67862 3.71346 5.23813C3.41128 4.79765 3.25 4.27977 3.25 3.75C3.25 3.0396 3.53973 2.35829 4.05546 1.85596C4.57118 1.35363 5.27065 1.07143 6 1.07143ZM6 0C5.23854 0 4.49418 0.219934 3.86105 0.631989C3.22793 1.04404 2.73446 1.62971 2.44306 2.31494C2.15167 3.00016 2.07542 3.75416 2.22398 4.48159C2.37253 5.20902 2.73921 5.8772 3.27764 6.40165C3.81607 6.9261 4.50208 7.28325 5.2489 7.42794C5.99573 7.57264 6.76984 7.49838 7.47333 7.21455C8.17683 6.93072 8.77812 6.45007 9.20116 5.83339C9.6242 5.2167 9.85 4.49168 9.85 3.75C9.85 2.75544 9.44438 1.80161 8.72236 1.09835C8.00035 0.395088 7.02108 0 6 0ZM11.5 15H10.4V12.3214C10.4 11.9697 10.3289 11.6214 10.1907 11.2964C10.0525 10.9714 9.84991 10.6761 9.59454 10.4274C9.33918 10.1787 9.03603 9.98136 8.70238 9.84675C8.36873 9.71214 8.01114 9.64286 7.65 9.64286H4.35C3.62065 9.64286 2.92118 9.92506 2.40546 10.4274C1.88973 10.9297 1.6 11.611 1.6 12.3214V15H0.5V12.3214C0.5 11.3269 0.905624 10.373 1.62764 9.66978C2.34965 8.96652 3.32892 8.57143 4.35 8.57143H7.65C8.67108 8.57143 9.65035 8.96652 10.3724 9.66978C11.0944 10.373 11.5 11.3269 11.5 12.3214V15Z" fill={currentElementId == "member-name" || newMember.name ? "var(--darkBlue)" : "#6d6d6d"}/>
                    </svg>
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "closeEnqDetails" || newMember.name ? "10px" : "14px", color: currentElementId == "member-name" || newMember.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Member Name</p>
                  </div>
                  <input id="member-name" value={newMember.name} placeholder="Enter Name" onChange={handleChange("member-name")} className={`${currentElementId == "member-name" || newMember.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                </div>
                <div onClick={toggleInputFields('member-phone')} className={`${currentElementId == "member-phone" || newMember.phone ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "member-phone" || newMember.phone ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "26%" : "100%" }}>
                  <div className="flex-item d-flex">
                    <svg  className="flex-item m-r-6" width={currentElementId == "member-phone" || newMember.phone ? "12" : "16"}  height={currentElementId == "member-phone" || newMember.phone ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 1.07143C6.5439 1.07143 7.07558 1.22852 7.52782 1.52285C7.98005 1.81717 8.33253 2.23551 8.54067 2.72496C8.74881 3.2144 8.80327 3.75297 8.69716 4.27256C8.59105 4.79216 8.32914 5.26943 7.94454 5.64404C7.55995 6.01864 7.06995 6.27375 6.5365 6.3771C6.00305 6.48046 5.45012 6.42741 4.94762 6.22468C4.44512 6.02194 4.01563 5.67862 3.71346 5.23813C3.41128 4.79765 3.25 4.27977 3.25 3.75C3.25 3.0396 3.53973 2.35829 4.05546 1.85596C4.57118 1.35363 5.27065 1.07143 6 1.07143ZM6 0C5.23854 0 4.49418 0.219934 3.86105 0.631989C3.22793 1.04404 2.73446 1.62971 2.44306 2.31494C2.15167 3.00016 2.07542 3.75416 2.22398 4.48159C2.37253 5.20902 2.73921 5.8772 3.27764 6.40165C3.81607 6.9261 4.50208 7.28325 5.2489 7.42794C5.99573 7.57264 6.76984 7.49838 7.47333 7.21455C8.17683 6.93072 8.77812 6.45007 9.20116 5.83339C9.6242 5.2167 9.85 4.49168 9.85 3.75C9.85 2.75544 9.44438 1.80161 8.72236 1.09835C8.00035 0.395088 7.02108 0 6 0ZM11.5 15H10.4V12.3214C10.4 11.9697 10.3289 11.6214 10.1907 11.2964C10.0525 10.9714 9.84991 10.6761 9.59454 10.4274C9.33918 10.1787 9.03603 9.98136 8.70238 9.84675C8.36873 9.71214 8.01114 9.64286 7.65 9.64286H4.35C3.62065 9.64286 2.92118 9.92506 2.40546 10.4274C1.88973 10.9297 1.6 11.611 1.6 12.3214V15H0.5V12.3214C0.5 11.3269 0.905624 10.373 1.62764 9.66978C2.34965 8.96652 3.32892 8.57143 4.35 8.57143H7.65C8.67108 8.57143 9.65035 8.96652 10.3724 9.66978C11.0944 10.373 11.5 11.3269 11.5 12.3214V15Z" fill={currentElementId == "member-phone" || newMember.phone ? "var(--darkBlue)" : "#6d6d6d"}/>
                    </svg>
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "member-phone" || newMember.phone ? "10px" : "14px", color: currentElementId == "member-phone" || newMember.phone ? "var(--darkBlue)" : "", transition: "180ms" }}>Member Phone</p>
                  </div>
                  <input id="member-phone" value={newMember.phone} placeholder="Enter Phone No." onChange={handleChange("member-phone")} className={`${currentElementId == "member-phone" || newMember.phone ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
                <div onClick={()=>{setSelectedPoolMembership(null); setMemberExistingNote(false)}} className="flex-item d-flex table-action-btn m-l-12 cursor-pointer" style={{background:"var(--red)"}}>
                  <svg className="flex-item margin-auto" width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14L14 1M14 14L1 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div onClick={()=>handleCheckExistingMember(membershipInfo)} className="flex-item d-flex table-action-btn m-l-12 cursor-pointer" style={{background:"#5d883c"}}>
                  <svg className="flex-item margin-auto" width="15" height="15" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 3.9737L2.74 6.50002L7.5 0.500015" stroke="white" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>,
              isMemberExistingNote && <p className="color-red font-weight-600 p-b-8 fs-12" style={{fontStyle:"italic"}}>Note - user already exists with this number</p>
            ] : (
              <div className={window.innerWidth < 768 ? "d-flex-wrap p-b-12" : "d-flex p-b-12"}>
                <div className="add-member-container space-between d-flex flex-item" style={{ width: window.innerWidth < 768 ? "100%" : undefined, marginBottom: window.innerWidth < 768 ? "10px" : undefined }}>
                  <input onClick={()=>handleSelectPoolMembership(membershipInfo)} onChange={handleSearchCustomer()} className="flex-item" type="text" value={selectedPoolMembership == membershipInfo._id ? customerSearchKey : ""} placeholder="Search Member" style={{width:"80%"}}/>
                  <div onClick={()=>toggleMemberList(membershipInfo)} className="flex-item table-action-btn d-flex cursor-pointer" style={{boxShadow:"0px 0px 4px rgba(0,0,0,0.25)", background: isMemberListOpen && selectedPoolMembership == membershipInfo._id && "#e33a34", transition:"180ms", transform: isMemberListOpen && selectedPoolMembership == membershipInfo._id ? "rotate(45deg)" : "rotate(0deg)"}}>
                    <svg className="flex-item margin-auto svg-fill" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C8.42758 0 8.77419 0.346618 8.77419 0.774194V7.22581H15.2258C15.6534 7.22581 16 7.57242 16 8C16 8.42758 15.6534 8.77419 15.2258 8.77419H8.77419V15.2258C8.77419 15.6534 8.42758 16 8 16C7.57242 16 7.22581 15.6534 7.22581 15.2258V8.77419H0.774194C0.346618 8.77419 0 8.42758 0 8C0 7.57242 0.346618 7.22581 0.774194 7.22581H7.22581V0.774194C7.22581 0.346618 7.57242 0 8 0Z" fill={isMemberListOpen && selectedPoolMembership == membershipInfo._id ? "#ffffff" : "var(--darkBlue)"}/>
                    </svg>
                  </div>
                  {
                    isMemberListOpen && selectedPoolMembership == membershipInfo._id && (
                      <div onScroll={handleCustomerListScroll} className="pool-members-list-container slideTopToBottom">
                        {
                          customers.length && customers.map(data => {
                            if(data.user?.[0]?.name && data.user?.[0]?.phone != props.selectedUsers.user[0].phone){
                              return(
                                <div className="global-input-field-arrow-dropdown-item d-flex space-between" style={{borderBottom:"1px solid #e0e0e0"}}>
                                  <div className="d-flex flex-item" style={{width:"90%"}}>
                                    {
                                      (data.user && data.user.length > 0) && (
                                        (data.user[0].profileID) ?
                                          <div className='tr-profile-image d-flex flex-item m-r-8'>
                                            <img id="gym-ImgWrapper" src={`${config.API_URL}/image/file/${data.user[0].profileID}/30/30/70?${Date.now()}`} loading='lazy' className="gym-logo" />
                                          </div> :
                                          <div className="tr-profile-image d-flex flex-item m-r-8" style={{backgroundColor: "#5d883c", width:"40px", height:"40px"}}>
                                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14, textTransform:"uppercase"}}>{`${data.user[0].name}`.trim()[0]}</p>
                                          </div>
                                      )
                                    }
                                    <div className="flex-item">
                                      <p className="flex-item" style={{fontSize:"15px", fontWeight:"600"}}>{data.user?.[0]?.name ? data.user[0].name : "--"}</p>
                                      <span className="flex-item" style={{fontSize:"12px"}}>+91 {data.user?.[0]?.phone ? data.user[0].phone : "--"}</span>
                                    </div>
                                  </div>
                                  <div onClick={()=>handleSelectCustomer(data, membershipInfo)} className="d-flex table-action-btn cursor-pointer flex-item" style={{boxShadow:"0px 0px 4px rgba(0,0,0,0.25)"}}>
                                    <svg className="flex-item margin-auto svg-fill" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C8.42758 0 8.77419 0.346618 8.77419 0.774194V7.22581H15.2258C15.6534 7.22581 16 7.57242 16 8C16 8.42758 15.6534 8.77419 15.2258 8.77419H8.77419V15.2258C8.77419 15.6534 8.42758 16 8 16C7.57242 16 7.22581 15.6534 7.22581 15.2258V8.77419H0.774194C0.346618 8.77419 0 8.42758 0 8C0 7.57242 0.346618 7.22581 0.774194 7.22581H7.22581V0.774194C7.22581 0.346618 7.57242 0 8 0Z" fill="var(--darkBlue)"/>
                                    </svg>
                                  </div>
                                </div>
                              )
                            }
                          })
                        }
                        {isCustomerSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                      </div>
                    )
                  }
                

                </div>

                {
                  window.innerWidth < 768 ? (
                    <div className="d-flex w-full" style={{justifyContent:"center", marginBottom:"10px"}}>
                      <div className="flex-item d-flex table-action-btn" style={{background:"#000000", width:"40px"}}>
                        <p className="flex-item margin-auto" style={{color:"#ffffff", fontSize:"12px"}}>OR</p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex-item d-flex table-action-btn m-l-12 m-r-12" style={{background:"#000000"}}>
                      <p className="flex-item margin-auto" style={{color:"#ffffff", fontSize:"12px"}}>OR</p>
                    </div>
                  )
                }

                <div onClick={()=>toggleAddNewMember(membershipInfo)} className="flex-item d-flex add-pool-member-button member-button-global cursor-pointer" style={{ width: window.innerWidth < 768 ? "100%" : "auto", justifyContent:"center" }}>
                  <p className="flex-item color-green font-weight-700" style={{whiteSpace:"nowrap"}}>Add New Member</p>
                </div>
              </div>
            )
          )
        }

        {/* newEntry.newMembers = [] */}
        {
          ((membershipInfo?.poolMembers && membershipInfo?.poolMembers.length > 0) || (membershipInfo?.newMembers && membershipInfo?.newMembers.length > 0)) && (
            <div className="d-flex-wrap" style={{paddingBottom: "12px", borderTop:"1px dashed #e0e0e0"}}>
              {
                membershipInfo?.poolMembers && membershipInfo?.poolMembers.length > 0 && membershipInfo?.poolMembers.map((member, index) => {
                  return (
                    <div className="selected-pool-member-info d-flex flex-item m-r-20 m-t-20">
                      {
                        (member.user && member.user.length > 0) && (
                          (member.user[0].profileID) ?
                            <div className='tr-profile-image d-flex flex-item m-r-8'>
                              <img id="gym-ImgWrapper" src={`${config.API_URL}/image/file/${member.user[0].profileID}/30/30/70?${Date.now()}`} loading='lazy' className="gym-logo" />
                            </div> :
                            <div className="tr-profile-image d-flex flex-item m-r-8" style={{backgroundColor: "#5d883c", width:"40px", height:"40px"}}>
                              <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14, textTransform:"uppercase"}}>{`${member.user[0].name}`.trim()[0]}</p>
                            </div>
                        )
                      }
                      <div className="flex-item">
                        <p className="flex-item" style={{fontSize:"15px", fontWeight:"600"}}>{member.user?.[0]?.name ? member.user[0].name : "--"}</p>
                        <span className="flex-item" style={{fontSize:"12px"}}>+91 {member.user?.[0]?.phone ? member.user[0].phone : "--"}</span>
                      </div>

                      <div onClick={()=>handleSelectCustomer(member, membershipInfo)} className="cancel-pool-membership d-flex">
                        <svg className="flex-item margin-auto" width="12" height="12" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 14L14 1M14 14L1 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  )
                })
              }
              {
                membershipInfo?.newMembers && membershipInfo?.newMembers.length > 0 && membershipInfo?.newMembers.map((member, index) => {
                  return (
                    <div className="selected-pool-member-info d-flex flex-item m-r-20 m-t-20">
                      <div className="tr-profile-image d-flex flex-item m-r-8" style={{backgroundColor: "#5d883c", width:"40px", height:"40px"}}>
                        <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14, textTransform:"uppercase"}}>{`${member.name}`.trim()[0]}</p>
                      </div>
                      <div className="flex-item">
                        <p className="flex-item" style={{fontSize:"15px", fontWeight:"600"}}>{member.name ? member.name : "--"}</p>
                        <span className="flex-item" style={{fontSize:"12px"}}>+91 {member.phone ? member.phone : "--"}</span>
                      </div>

                      <div onClick={()=>handleAddNewCustomer(membershipInfo, member)} className="cancel-pool-membership d-flex">
                        <svg className="flex-item margin-auto" width="12" height="12" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 14L14 1M14 14L1 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          )
        }

        <div className="p-b-8 m-t-12" style={{fontStyle:"italic", fontSize:"12px", opacity:"0.8"}}>
          <span className="color-black font-weight-600 color-dark-blue">Note - </span>
          {
            membershipInfo?.packages?.poolCharges && (
              window.innerWidth < 768 ? (
               
                Array.from({ length: Math.ceil(membershipInfo.packages.poolCharges.length / 2) }).map((_, rowIndex) => {
                  const rowItems = membershipInfo.packages.poolCharges.slice(rowIndex * 2, rowIndex * 2 + 2);
                  return (
                    <div className="d-flex" style={{marginTop:"2px"}}>
                      {
                        rowItems.map((pc, i) => (
                          <span className="font-weight-700 color-dark-blue m-r-8">
                            1 + {pc.poolMembersAllowed} pooling: <span className="color-red">{pc.percentage ? pc.percentage : 0}%</span>{i != rowItems.length - 1 && ","}
                          </span>
                        ))
                      }
                    </div>
                  )
                })
              ) : (
                
                <span className="font-weight-600 color-dark-blue">
                  {
                    membershipInfo.packages.poolCharges.map((pc, pci) => (
                      <span className="font-weight-700">1 + {pc.poolMembersAllowed} pooling: <span className="color-red m-r-6">{pc.percentage ? pc.percentage : 0}% {membershipInfo.packages.poolCharges.length != pci + 1 && ", "}</span></span>
                    ))
                  }
                </span>
              )
            )
          }
          <span className="color-green">(Pool Charges)</span>
        </div>
      </div>
    )
  }

  const handleAllowPoolMembership = () => {
    setAllowPoolMembership(!allowPoolMembership)
    if(allowPoolMembership){
      setCloseEnqDetails(prev => ({
        ...prev,
        selectedMemberships: [],
      }));
      setBillingInfo({
        selectedPlansPrice: 0,
        selectedPlansDiscount: 0,
        baseAmount:0,
        taxableAmount:0,
        subTotal: 0,
        poolCharge: 0,
        surCharges: 0,
        taxBreakup: [],
        totalTax: 0,
        payableAmount: 0,
        remainingAmount: 0
      });
    }
  }

  const applyGSTPaidAmount = () => {
    setBillingInfo(prev => ({
      ...prev,
      GstOnPaidAmount: !prev.GstOnPaidAmount
    }))
    if(billingInfo.GstOnPaidAmount){
      setCloseEnqDetails(prev=>({...prev, paidDiscount: ""}));
    }
    setEditBillingInfoSubTotal(false)
  }

  const generateRazorpayPaymentLink = async (memberInfo) => {
    try{

      let params = {
        gymId: memberInfo.gymId,
        branchId: memberInfo.branch[0]._id,
        amount: closeEnqDetails.amountPaid,
        memberId: memberInfo.userInfo.userId,
        memberName: memberInfo.user[0].name,
        memberEmail: memberInfo.user[0].email,
        memberPhone: memberInfo.user[0].phone
      }

      const response = await generatePaymentLink(user._id, token, params);

      if(!response.error){

        console.log(response);
        setRazorpayInfo(response);
        
        new Toast({
          type:'success',
          message:'Payment link generated successfully',
          duration:3000
        });

      }else{
        new Toast({
          type:'error',
          message:response.error,
          duration:3000
        });
      }

    }catch(err){
      new Toast({
        type:'error',
        message:"Couldn't generate Payment Link",
        duration:3000
      });
    }
  }

  const [copied, setCopied] = useState(false);

  const handleCopyLink = async (shortUrl) => {
    try {
      await navigator.clipboard.writeText(shortUrl);
      new Toast({
        type:'success',
        message:"Payment Link Copied !",
        duration:3000
      });
    } catch (err) {
      new Toast({
        type:'error',
        message:"Couldn't Copy Payment Link !",
        duration:3000
      });
    }
  };

  const cancelPayment = () => {
    setRazorpayInfo(null);
  }

  useEffect(() => {
    if (!razorpayInfo || !razorpayInfo.id) return;

    const checkStatus = async () => {

      try {
        const response = await getPaymentConfirmation(user._id, token, razorpayInfo.id);
        console.log(response);
        console.log(razorpayInfo);

        if (!response.error && response.razorPay.razorpayPaymentId) {
          clearInterval(intervalRef.current);
          setPaymentStatus(response);
        }
      } catch (err) {
        console.error('Status check failed:', err);
      }
    };

    intervalRef.current = setInterval(checkStatus, 3000);
    const timeout = setTimeout(() => clearInterval(intervalRef.current), 5 * 60 * 1000);

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeout);
    };

  }, [razorpayInfo]);

  useEffect(()=>{
    GetAllTaxes();
    GetAllUser();
    GetAllEmployees();
  },[])


  useEffect(async ()=>{
    try{
      await startLoader()

      await GetMembershipPlans(true);
      await GetMembershipPlanCount();

    }catch(error){

    }

    await stopLoader();
  },[selectedMembershipType, allowPoolMembership]);


  const isSyncingRef = useRef(false);

  useEffect(() => {
    if (!closeEnqDetails?.selectedMemberships?.length) return;
    if (isSyncingRef.current) {
      isSyncingRef.current = false;
      return;
    }

    let totalSelectedPlansPrice = 0;
    let totalSelectedPlansDiscount = 0;
    let totalBaseAmount = 0;
    let totalTax = 0;
    let totalSubTotal = 0;
    let totalPayableAmount = 0;
    let taxBreakup = [];
    let totalPoolCharge = 0;


    const surchargePercent =
      closeEnqDetails.selectedMemberships[0]?.surchargePercent ||
      closeEnqDetails.surCharges ||
      0;

    taxBreakup = taxes.map((tax) => ({ ...tax, amount: "0" }));

    const updatedMemberships = closeEnqDetails.selectedMemberships.map((membership) => {

      const rackRate = membership.packages?.rackRate || 0;

      const totalPoolMembers = ((membership?.poolMembers?.length || 0) + (membership?.newMembers?.length || 0))
      let poolCharge = 0;
      if(totalPoolMembers > 0){
        const poolChargeObj = membership.packages.poolCharges.find(pc => pc.poolMembersAllowed == totalPoolMembers);
        const poolPercentage = poolChargeObj?.percentage || 0;

        if(poolPercentage > 0){
          poolCharge = (Number(rackRate) * Number(poolPercentage)) / 100;
        }
      }

      totalPoolCharge += poolCharge;

      const discount = parseFloat(membership.membershipDiscount || 0);
      // const baseAmount = rackRate - discount;

      const baseAmount = Math.max(
        0,
        rackRate -
          discount -
          (
            props.type === "upgrade-membership"
              ? parseFloat(amountPaid || 0)
              : 0
          )
      );

      totalSelectedPlansPrice += rackRate;
      totalSelectedPlansDiscount += discount;
      totalBaseAmount += baseAmount;

      const surCharges = (baseAmount * surchargePercent) / 100;

      let membershipTotalTax = 0;
      let membershipTaxBreakup = [];

      if (taxType && taxes.length) {
        const totalTaxPercent = taxes.reduce(
          (sum, t) => sum + (parseFloat(t.value) || 0),
          0
        );

        const finalTaxableAmount = billingInfo.GstOnPaidAmount ? closeEnqDetails.amountPaid : baseAmount;

        if (taxType === "inclusive-tax") {

          const inclusiveTax = (finalTaxableAmount * totalTaxPercent) / (100 + totalTaxPercent);

          membershipTaxBreakup = taxes.map((tax) => {
            const amount = (inclusiveTax * parseFloat(tax.value)) / totalTaxPercent;
            membershipTotalTax += amount;
            return { ...tax, amount: amount.toFixed(2) };
          });

        } else if (taxType === "additional-tax") {
          membershipTaxBreakup = taxes.map((tax) => {
            const amount = (finalTaxableAmount * parseFloat(tax.value)) / 100;
            membershipTotalTax += amount;
            return { ...tax, amount: amount.toFixed(2) };
          });
        }

        taxBreakup = taxBreakup.map((tb, i) => ({
          ...tb,
          amount: (
            parseFloat(tb.amount) + parseFloat(membershipTaxBreakup[i]?.amount || 0)
          ).toFixed(2),
        }));
      }

      const subTotal = taxType === "inclusive-tax" ? baseAmount + poolCharge : baseAmount + poolCharge + membershipTotalTax;
      const payableAmount = subTotal + surCharges;

      totalTax += membershipTotalTax;
      totalSubTotal += subTotal;
      totalPayableAmount += payableAmount;


      return {
        ...membership,
        baseAmount: Math.round(baseAmount),
        ...(poolCharge > 0 && {poolCharge: Math.round(poolCharge)}),
        totalTax: Math.round(membershipTotalTax),
        subTotal: Math.round(subTotal),
        payableAmount: Math.round(payableAmount),
        surCharges: Math.round(surCharges),
      };
    });

    const isGstOnPaid = billingInfo.GstOnPaidAmount;
    const paidBase = parseFloat(closeEnqDetails.amountPaid || 0);
    const paidDiscount = parseFloat(closeEnqDetails.paidDiscount || 0);
    let taxableAmount, subTotal, payableAmount, remainingAmount, surChargesTotal;
    const paidAmount = Number(amountPaid || 0);
    if (isGstOnPaid) {
      const rate = taxes.reduce((s,t)=>s+parseFloat(t.value||0),0);
      let paidTax = 0;
      if (taxType==="additional-tax") paidTax = paidBase*rate/100;
      else if (taxType==="inclusive-tax") paidTax = paidBase*rate/(100+rate);
      totalTax = paidTax;
      taxBreakup = taxes.map(tx=>({...tx, amount: rate ? (paidTax*parseFloat(tx.value)/rate).toFixed(2) : "0.00"}));
      taxableAmount = taxType==="inclusive-tax" ? paidBase-paidTax : paidBase;
      subTotal = taxType==="additional-tax" ? paidBase+paidTax : paidBase;
      surChargesTotal = paidBase*surchargePercent/100;
      payableAmount = subTotal+surChargesTotal;
      remainingAmount = Math.max(0, (totalBaseAmount+totalPoolCharge)-paidBase-paidDiscount);
    } 
    else {
      
      surChargesTotal = (totalBaseAmount * surchargePercent) / 100;
      taxableAmount = taxType === "inclusive-tax" ? totalBaseAmount + totalPoolCharge - totalTax : totalBaseAmount + totalPoolCharge;
      subTotal = taxType === "inclusive-tax" ? totalBaseAmount + totalPoolCharge : totalBaseAmount + totalPoolCharge + totalTax;
      payableAmount = subTotal + surChargesTotal;
      remainingAmount = payableAmount - (closeEnqDetails.amountPaid || 0);
    }
    setBillingInfo((prev) => ({
      ...prev,
      selectedPlansPrice: Math.round(totalSelectedPlansPrice),
      selectedPlansDiscount: Math.round(totalSelectedPlansDiscount),
      taxBreakup,
      baseAmount: Math.round(totalBaseAmount - paidAmount),
      taxableAmount: Math.round(taxableAmount),
      subTotal: Math.round(subTotal),
      ...(totalPoolCharge > 0 && {poolCharge: Math.round(totalPoolCharge)}),
      surCharges: Math.round(surChargesTotal),
      payableAmount: Math.round(payableAmount),
      remainingAmount: Math.round(remainingAmount),
      totalTax: Math.round(totalTax),
    }));

    isSyncingRef.current = true;
    setCloseEnqDetails((prev) => ({
      ...prev,
      selectedMemberships: updatedMemberships,
    }));

  }, [closeEnqDetails, taxType, taxes, amountPaid]);

  useEffect(() => {
    const isValid =
      closeEnqDetails.amountPaid &&
      closeEnqDetails.invoiceDate &&
      closeEnqDetails.date &&
      (membershipBillingConfig?.aadhar == true ? closeEnqDetails.aadharNumber : true) &&
      (closeEnqDetails.selectedMemberships.some(m => m.type === "PersonalTraining") ? closeEnqDetails.selectedTrainer !== "" : true) &&
      (closeEnqDetails.paymentMode == "Razorpay" ? razorpayInfo != null && paymentStatus != null : true) && 
      closeEnqDetails.selectedMemberships.every(
        m => m.endDate !== "" && m.endDate != null
      );

    setButtonLock(!isValid);
  }, [closeEnqDetails, billingInfo, selectedMembershipType, paymentStatus]);


  useEffect(() => {
    if (closeEnqDetails.date && closeEnqDetails.selectedMemberships.length > 0) {
      setCloseEnqDetails(prev => ({
        ...prev,
        selectedMemberships: prev.selectedMemberships.map(m => ({
          ...m,
          endDate: (() => {
            const pkg = m.packages;
            const startDate = closeEnqDetails.date;

            if (!startDate || !pkg) return null;

            const { duration, durationType } = pkg;

            const type = durationType
              ?.toLowerCase()
              .replace(/s$/, "")
              .replace("(s)", "")
              .trim();

            if (type === "month") {
              const raw = dayjs(startDate).add(duration, "month");
              const isClamped =
                raw.date() !== dayjs(startDate).date();

              return isClamped
                ? raw.toISOString()
                : raw.subtract(1, "day").toISOString();
            }

            if (type === "week") {
              return dayjs(startDate)
                .add(duration, "week")
                .subtract(1, "day")
                .toISOString();
            }

            if (type === "day") {
              return dayjs(startDate)
                .add(duration, "day")
                .subtract(1, "day")
                .toISOString();
            }

            return null;
          })(),
        })),
      }));
    }
  }, [closeEnqDetails.date]);

  const handleMembershipScroll = throttle(async (event) => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isMemberShipSpinnerLoader) {
        if (pageNo < pageCount) {
          pageNo = pageNo + 1;
          setPageNo(pageNo)
          setMemberShipSpinnerLoader(true);
          await GetMembershipPlans();
          setMemberShipSpinnerLoader(false)
        }
      }
    } catch (error) {
      setMemberShipSpinnerLoader(false)
    }
  }, 800);

  useEffect(async()=>{
    if(props.selectedUsers.payments && props.type == "upgrade-membership"){
      let amount = ([...props.selectedUsers.payments,...props.selectedUsers.balance_payments] || []).reduce((sum, p) => sum + Number(p?.amount?.$numberDecimal || 0), 0);
      setAmountPaid(amount);
    }

    try{
      const response = await getBranchConfig(user._id, token, localStorage.getItem("branchId"));

      if(!response.error){
        setMembershipBillingConfig(response.branchConfig.membershipConfig)
      }

    }catch(err){
      
      new Toast({
        type:'error',
        message:"Could'nt fetch branch configurations",
        duration:3000
      });
    }

  },[props]);

  useEffect(()=>{
    console.log(membershipBillingConfig)
  },[membershipBillingConfig])

  useEffect(() => {
    if(props.selectedUsers && props.selectedUsers?.user?.[0]){
      setCloseEnqDetails(prev => ({
        ...prev,
        emergencyContactName: props.selectedUsers.user[0]?.emergency_contact_name,
        emergencyContactNumber: props.selectedUsers.user[0]?.emergency_contact_no,
        panNumber: props.selectedUsers.user[0]?.pan_number,
        aadharNumber: props.selectedUsers.user[0]?.aadhar_number,
        gstinNumber: props.selectedUsers.user[0]?.gstin_number,
      }))
    }
    // console.log(props.selectedUsers)
  },[props.selectedUsers])

  useEffect(() => {
    GetAllCustomer(true);
  },[customerSearchKey])
  const isDueDateMissing = billingInfo.remainingAmount > 0 && !closeEnqDetails.paymentDueDate;
  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container d-flex flex-item" style={{width: window.innerWidth > 767 && "60%", height: window.innerWidth > 767 && "94%", position:"relative"}}>

        {
          (razorpayInfo != null && paymentStatus == null) && (
            <div className="razorpay-container d-flex fadeIn flex-item">
              <div className="razorpay-body flex-item d-flex">
                <div className="margin-auto d-flex flex-item" style={{width:"50%", height:"96%"}}>
                  {/* <div className="d-flex">
                    <img className="flex-item margin-auto" style={{width:"120px", height:"auto"}} src={RazorPayLogo} />
                  </div> */}
                  <div className="flex-item w-full slideBottomToTop" style={{borderRadius:"20px", height:"auto", padding:"12px", background:"#181818", display:"flex", flexDirection:"column"}}>
                    <div className="d-flex space-between w-full p-b-12 m-b-8" style={{borderBottom:"1px solid #626262"}}>
                      <div className="d-flex flex-item">
                        <div className="d-flex">
                          {
                            (props.selectedUsers.user.length && props.selectedUsers.user[0].profileID)?(
                              <div className="table-item-profile d-flex flex-item">
                                <img className="flex-item" src={`${config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/30/30/70?${Date.now()}`} />
                              </div>
                            ):(
                              <div className="table-item-profile d-flex flex-item" style={{backgroundColor: "#424242", margin:"0"}}>
                                <p className='flex-item margin-auto' style={{color: "#ffffff"}}>
                                  {`${props.selectedUsers.user[0].name}`.trim()[0]}
                                </p>
                              </div>
                            )
                          }
                        </div>
                        <div className="flex-item m-l-8">
                          <p className="fs-16 color-grey-09" style={{textAlign:"left"}}>{props.selectedUsers.user[0].name}</p>
                          <p className="fs-10 color-white" style={{textAlign:"left", fontWeight:400}}>{props.selectedUsers.user[0].phone}</p>
                        </div>
                      </div>
                      <div onClick={()=>cancelPayment()} className="d-flex desktop-modal-close-button" style={{width: "30px", margin:0, height:"30px", background:"#f9f9f9"}}>
                        <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                        </svg>
                      </div>
                    </div>
                    <div className="w-full" style={{flex:1, overflowY:"auto", minHeight:0}}>
                      <p className="flex-item margin-auto m-b-4 fs-16 font-weight-700" style={{color:"#3395FF"}}>Scan to Pay</p>
                      <div className="flex-item d-flex scanner-container margin-auto">
                        <img className="flex-item margin-auto" src={razorpayInfo.qrCode} alt="Scan to pay" />
                      </div>

                      <div className="d-flex m-t-18 m-b-18">
                        <div className="d-flex margin-auto">
                          <svg className="flex-item m-r-6" width="16" height="16" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.75 0C2.02065 0 1.32118 0.289731 0.805456 0.805456C0.289731 1.32118 0 2.02065 0 2.75V21.25C0 21.9793 0.289731 22.6788 0.805456 23.1945C1.32118 23.7103 2.02065 24 2.75 24H11.25C11.9793 24 12.6788 23.7103 13.1945 23.1945C13.7103 22.6788 14 21.9793 14 21.25V2.75C14 2.02065 13.7103 1.32118 13.1945 0.805456C12.6788 0.289731 11.9793 0 11.25 0H2.75ZM1.5 2.75C1.5 2.06 2.06 1.5 2.75 1.5H11.25C11.94 1.5 12.5 2.06 12.5 2.75V21.25C12.5 21.94 11.94 22.5 11.25 22.5H2.75C2.06 22.5 1.5 21.94 1.5 21.25V2.75ZM5.25 19C5.05109 19 4.86032 19.079 4.71967 19.2197C4.57902 19.3603 4.5 19.5511 4.5 19.75C4.5 19.9489 4.57902 20.1397 4.71967 20.2803C4.86032 20.421 5.05109 20.5 5.25 20.5H8.75C8.94891 20.5 9.13968 20.421 9.28033 20.2803C9.42098 20.1397 9.5 19.9489 9.5 19.75C9.5 19.5511 9.42098 19.3603 9.28033 19.2197C9.13968 19.079 8.94891 19 8.75 19H5.25Z" fill="#3395FF"/>
                          </svg>
                          <p className="flex-item fs-12" style={{color:"#ffffff"}}>Scan QR or use the payment link below</p>
                        </div>
                      </div>

                      <div onClick={()=>handleCopyLink(razorpayInfo.shortUrl)} className="flex-item d-flex m-t-12 payment-link-container space-between p-l-12 p-r-12 cursor-pointer">
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-8" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7285 3.88438C17.1625 2.44438 19.2605 2.41438 20.4215 3.58038C21.5855 4.74838 21.5545 6.86038 20.1185 8.30038L17.6955 10.7334C17.559 10.875 17.4837 11.0646 17.4857 11.2612C17.4877 11.4579 17.5668 11.6459 17.7061 11.7848C17.8453 11.9236 18.0335 12.0022 18.2302 12.0037C18.4269 12.0051 18.6162 11.9292 18.7575 11.7924L21.1815 9.35938C23.0925 7.44038 23.3325 4.37738 21.4845 2.52138C19.6345 0.664382 16.5775 0.906382 14.6645 2.82538L9.81846 7.69238C7.90746 9.61138 7.66746 12.6744 9.51546 14.5294C9.58448 14.6012 9.6671 14.6585 9.75851 14.698C9.84991 14.7375 9.94827 14.7584 10.0478 14.7595C10.1474 14.7606 10.2462 14.7418 10.3385 14.7043C10.4307 14.6668 10.5146 14.6114 10.5851 14.5411C10.6557 14.4709 10.7116 14.3873 10.7495 14.2952C10.7875 14.2031 10.8067 14.1044 10.8061 14.0048C10.8054 13.9053 10.785 13.8068 10.7459 13.7152C10.7068 13.6236 10.6499 13.5407 10.5785 13.4714C9.41446 12.3034 9.44646 10.1914 10.8815 8.75138L15.7285 3.88438Z" fill="#3395FF"/>
                            <path d="M14.4855 9.46962C14.3449 9.32866 14.1541 9.24931 13.955 9.24902C13.7559 9.24874 13.5649 9.32755 13.424 9.46812C13.283 9.60868 13.2036 9.79949 13.2034 9.99856C13.2031 10.1976 13.2819 10.3887 13.4225 10.5296C14.5865 11.6976 14.5555 13.8086 13.1195 15.2496L8.27246 20.1156C6.83746 21.5556 4.73946 21.5856 3.57846 20.4196C2.41446 19.2516 2.44646 17.1396 3.88146 15.6996L6.30546 13.2666C6.37499 13.1968 6.4301 13.114 6.46763 13.0229C6.50516 12.9318 6.52439 12.8342 6.5242 12.7357C6.52401 12.6372 6.50442 12.5397 6.46655 12.4487C6.42868 12.3578 6.37326 12.2752 6.30346 12.2056C6.23366 12.1361 6.15085 12.081 6.05976 12.0434C5.96866 12.0059 5.87107 11.9867 5.77254 11.9869C5.67402 11.9871 5.5765 12.0067 5.48555 12.0445C5.3946 12.0824 5.31199 12.1378 5.24246 12.2076L2.81846 14.6406C0.907459 16.5606 0.667459 19.6226 2.51546 21.4786C4.36546 23.3366 7.42246 23.0936 9.33546 21.1746L14.1825 16.3076C16.0935 14.3896 16.3335 11.3246 14.4855 9.46962Z" fill="#3395FF"/>
                          </svg>
                          <p className="flex-item fs-16 font-weight-600" style={{color:"#3395FF"}}>{razorpayInfo.shortUrl}</p>
                        </div>
                        <svg className="flex-item svg-stroke " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 11C6 8.172 6 6.757 6.879 5.879C7.757 5 9.172 5 12 5H15C17.828 5 19.243 5 20.121 5.879C21 6.757 21 8.172 21 11V16C21 18.828 21 20.243 20.121 21.121C19.243 22 17.828 22 15 22H12C9.172 22 7.757 22 6.879 21.121C6 20.243 6 18.828 6 16V11Z" stroke="#ffffff" stroke-width="1.5"/>
                          <path d="M6 19C5.20435 19 4.44129 18.6839 3.87868 18.1213C3.31607 17.5587 3 16.7956 3 16V10C3 6.229 3 4.343 4.172 3.172C5.344 2.001 7.229 2 11 2H15C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5" stroke="#ffffff" stroke-width="1.5"/>
                        </svg>
                      </div>

                      {/* <div className="d-flex space-between m-t-12">
                        <div onClick={()=>handleCopyLink(razorpayInfo.shortUrl)} className="payment-action payment-action-copy flex-item d-flex" style={{border:"1px solid #9a9a9a"}}>
                          <svg className="flex-item m-r-8 svg-stroke" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 11C6 8.172 6 6.757 6.879 5.879C7.757 5 9.172 5 12 5H15C17.828 5 19.243 5 20.121 5.879C21 6.757 21 8.172 21 11V16C21 18.828 21 20.243 20.121 21.121C19.243 22 17.828 22 15 22H12C9.172 22 7.757 22 6.879 21.121C6 20.243 6 18.828 6 16V11Z" stroke="#ffffff" stroke-width="1.5"/>
                            <path d="M6 19C5.20435 19 4.44129 18.6839 3.87868 18.1213C3.31607 17.5587 3 16.7956 3 16V10C3 6.229 3 4.343 4.172 3.172C5.344 2.001 7.229 2 11 2H15C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5" stroke="#ffffff" stroke-width="1.5"/>
                          </svg>
                          <p className="flex-item color-white">Copy Link</p>
                        </div>
                        <div className="payment-action flex-item d-flex" style={{background:"#5d883c"}}>
                          <svg className="flex-item m-r-8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 2.91005C16.0831 1.98416 14.991 1.25002 13.7875 0.750416C12.584 0.250812 11.2931 -0.00426317 9.99 5.38951e-05C4.53 5.38951e-05 0.0800002 4.45005 0.0800002 9.91005C0.0800002 11.6601 0.54 13.3601 1.4 14.8601L0 20.0001L5.25 18.6201C6.7 19.4101 8.33 19.8301 9.99 19.8301C15.45 19.8301 19.9 15.3801 19.9 9.92005C19.9 7.27005 18.87 4.78005 17 2.91005ZM9.99 18.1501C8.51 18.1501 7.06 17.7501 5.79 17.0001L5.49 16.8201L2.37 17.6401L3.2 14.6001L3 14.2901C2.17755 12.9771 1.74092 11.4593 1.74 9.91005C1.74 5.37005 5.44 1.67005 9.98 1.67005C12.18 1.67005 14.25 2.53005 15.8 4.09005C16.5676 4.85392 17.1759 5.7626 17.5896 6.76338C18.0033 7.76417 18.2142 8.83714 18.21 9.92005C18.23 14.4601 14.53 18.1501 9.99 18.1501ZM14.51 11.9901C14.26 11.8701 13.04 11.2701 12.82 11.1801C12.59 11.1001 12.43 11.0601 12.26 11.3001C12.09 11.5501 11.62 12.1101 11.48 12.2701C11.34 12.4401 11.19 12.4601 10.94 12.3301C10.69 12.2101 9.89 11.9401 8.95 11.1001C8.21 10.4401 7.72 9.63005 7.57 9.38005C7.43 9.13005 7.55 9.00005 7.68 8.87005C7.79 8.76005 7.93 8.58005 8.05 8.44005C8.17 8.30005 8.22 8.19005 8.3 8.03005C8.38 7.86005 8.34 7.72005 8.28 7.60005C8.22 7.48005 7.72 6.26005 7.52 5.76005C7.32 5.28005 7.11 5.34005 6.96 5.33005H6.48C6.31 5.33005 6.05 5.39005 5.82 5.64005C5.6 5.89005 4.96 6.49005 4.96 7.71005C4.96 8.93005 5.85 10.1101 5.97 10.2701C6.09 10.4401 7.72 12.9401 10.2 14.0101C10.79 14.2701 11.25 14.4201 11.61 14.5301C12.2 14.7201 12.74 14.6901 13.17 14.6301C13.65 14.5601 14.64 14.0301 14.84 13.4501C15.05 12.8701 15.05 12.3801 14.98 12.2701C14.91 12.1601 14.76 12.1101 14.51 11.9901Z" fill="white"/>
                          </svg>
                          <p className="flex-item color-white">Whatsapp</p>
                        </div> 
                      </div> */}
                      <div className="w-full d-flex m-t-30">
                        <div class="dots-loader margin-auto">
                          <span></span><span></span><span></span><span></span>
                        </div>
                      </div>
                      <div className="d-flex m-t-12">
                        <p className="margin-auto flex-item color-grey-08">Waiting for payment...</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0", zIndex:10, position:"absolute", top:0}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.75 6.62484C10.75 6.50328 10.7983 6.3867 10.8843 6.30074C10.9702 6.21479 11.0868 6.1665 11.2083 6.1665H12.125C12.2466 6.1665 12.3632 6.21479 12.4491 6.30074C12.535 6.3867 12.5833 6.50328 12.5833 6.62484V7.5415C12.5833 7.66306 12.535 7.77964 12.4491 7.8656C12.3632 7.95155 12.2466 7.99984 12.125 7.99984H11.2083C11.0868 7.99984 10.9702 7.95155 10.8843 7.8656C10.7983 7.77964 10.75 7.66306 10.75 7.5415V6.62484Z" fill="#ffffff"/>
                  <path d="M3.87435 0.666504C3.9959 0.666504 4.11249 0.714792 4.19844 0.800746C4.2844 0.886701 4.33268 1.00328 4.33268 1.12484V1.58317H11.666V1.12484C11.666 1.00328 11.7143 0.886701 11.8003 0.800746C11.8862 0.714792 12.0028 0.666504 12.1243 0.666504C12.2459 0.666504 12.3625 0.714792 12.4484 0.800746C12.5344 0.886701 12.5827 1.00328 12.5827 1.12484V1.58317H13.4993C13.9855 1.58317 14.4519 1.77632 14.7957 2.12014C15.1395 2.46396 15.3327 2.93027 15.3327 3.4165V13.4998C15.3327 13.986 15.1395 14.4524 14.7957 14.7962C14.4519 15.14 13.9855 15.3332 13.4993 15.3332H2.49935C2.01312 15.3332 1.54681 15.14 1.20299 14.7962C0.85917 14.4524 0.666016 13.986 0.666016 13.4998V3.4165C0.666016 2.93027 0.85917 2.46396 1.20299 2.12014C1.54681 1.77632 2.01312 1.58317 2.49935 1.58317H3.41602V1.12484C3.41602 1.00328 3.4643 0.886701 3.55026 0.800746C3.63621 0.714792 3.75279 0.666504 3.87435 0.666504ZM1.58268 4.33317V13.4998C1.58268 13.743 1.67926 13.9761 1.85116 14.148C2.02307 14.3199 2.25623 14.4165 2.49935 14.4165H13.4993C13.7425 14.4165 13.9756 14.3199 14.1475 14.148C14.3195 13.9761 14.416 13.743 14.416 13.4998V4.33317H1.58268Z" fill="#ffffff"/>
                </svg>
                <p className="flex-item fs-18 color-white">{props.type == "upgrade-membership" ? "Upgrade Membership" : props.type == "NEWSALE"? "Renew / Add Membership":"Close Enquiry"}</p>
              </div>
              <div onClick={props.handleCloseModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        {
          props.selectedUsers.user && props.selectedUsers.user.length > 0 && (
            <div className={`${window.innerWidth < 640 ? "m-t-8" : "m-t-70"} w-full`} style={{height: window.innerWidth > 767 ? "88%" : "100%"}}>
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "0 12px 40px 12px" : "12px 12px 100px 12px"}}>
                <div className="selected-enq-user-list-scroll-container slideTopToBottom bg-white" style={{height:"", maxHeight:"90%"}}>
                  <div className="d-flex w-full space-between">
                    <div className="d-flex">
                      {
                      (props.selectedUsers.user.length && props.selectedUsers.user[0].profileID)?(
                        <div className="table-item-profile d-flex flex-item">
                            <img className="flex-item" src={`${config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/30/30/70?${Date.now()}`} />
                        </div>
                      ):(
                        <div className="table-item-profile d-flex flex-item" style={{
                          backgroundColor: "#5d883c"
                        }}>
                          <p className='flex-item' style={{
                            color: "#ffffff",
                            margin: "0 auto",
                            fontSize: 14,
                          }}>{`${props.selectedUsers.user[0].name}`.trim()[0]}</p>
                        </div>

                      )
                      }
                      <div className="flex-item m-l-8">
                        <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{props.selectedUsers.user[0].name}</p>
                        <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{props.selectedUsers.user[0].phone}</p>
                      </div>
                    </div>
                    <div onClick={()=>toggleUserDetails()} className="table-action-button d-flex flex-item" style={{backgroundColor: isUserDetailsOpen ? "#E33A34" : "#ffffff"}}>
                      <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isUserDetailsOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isUserDetailsOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                      </svg>
                    </div>
                  </div>
                  {
                    isUserDetailsOpen && (
                      <div className="w-full m-t-20 d-flex-wrap space-between">
                        <div onClick={toggleInputFields('emergency-contact-name')} className={`${currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                          <div className="flex-item d-flex">
                            <svg  className="flex-item m-r-6" width={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "12" : "16"}  height={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 1.07143C6.5439 1.07143 7.07558 1.22852 7.52782 1.52285C7.98005 1.81717 8.33253 2.23551 8.54067 2.72496C8.74881 3.2144 8.80327 3.75297 8.69716 4.27256C8.59105 4.79216 8.32914 5.26943 7.94454 5.64404C7.55995 6.01864 7.06995 6.27375 6.5365 6.3771C6.00305 6.48046 5.45012 6.42741 4.94762 6.22468C4.44512 6.02194 4.01563 5.67862 3.71346 5.23813C3.41128 4.79765 3.25 4.27977 3.25 3.75C3.25 3.0396 3.53973 2.35829 4.05546 1.85596C4.57118 1.35363 5.27065 1.07143 6 1.07143ZM6 0C5.23854 0 4.49418 0.219934 3.86105 0.631989C3.22793 1.04404 2.73446 1.62971 2.44306 2.31494C2.15167 3.00016 2.07542 3.75416 2.22398 4.48159C2.37253 5.20902 2.73921 5.8772 3.27764 6.40165C3.81607 6.9261 4.50208 7.28325 5.2489 7.42794C5.99573 7.57264 6.76984 7.49838 7.47333 7.21455C8.17683 6.93072 8.77812 6.45007 9.20116 5.83339C9.6242 5.2167 9.85 4.49168 9.85 3.75C9.85 2.75544 9.44438 1.80161 8.72236 1.09835C8.00035 0.395088 7.02108 0 6 0ZM11.5 15H10.4V12.3214C10.4 11.9697 10.3289 11.6214 10.1907 11.2964C10.0525 10.9714 9.84991 10.6761 9.59454 10.4274C9.33918 10.1787 9.03603 9.98136 8.70238 9.84675C8.36873 9.71214 8.01114 9.64286 7.65 9.64286H4.35C3.62065 9.64286 2.92118 9.92506 2.40546 10.4274C1.88973 10.9297 1.6 11.611 1.6 12.3214V15H0.5V12.3214C0.5 11.3269 0.905624 10.373 1.62764 9.66978C2.34965 8.96652 3.32892 8.57143 4.35 8.57143H7.65C8.67108 8.57143 9.65035 8.96652 10.3724 9.66978C11.0944 10.373 11.5 11.3269 11.5 12.3214V15Z" fill={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "var(--darkBlue)" : "#6d6d6d"}/>
                            </svg>
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "closeEnqDetails" || closeEnqDetails.emergencyContactName ? "10px" : "14px", color: currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Name</p>
                          </div>
                          <input id="emergency-contact-name" value={closeEnqDetails.emergencyContactName} placeholder="Enter Name" onChange={handleChange("emergencyContactName")} className={`${currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "active-input-field" : "inactive-input-field"}`} type="text" />
                        </div>
                        <div onClick={toggleInputFields('emergency-contact-phone')} className={`${currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                          <div className="flex-item d-flex">
                            <svg  className="flex-item m-r-6" width={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "12" : "16"}  height={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.38594 4.93194C1.12884 3.31997 2.32597 1.86957 4.15474 1.33738C4.47945 1.24295 4.82984 1.26978 5.13443 1.4124C5.43903 1.55503 5.67489 1.8027 5.79389 2.10489L6.38031 3.59248C6.47459 3.83176 6.4915 4.09236 6.42886 4.34084C6.36621 4.58932 6.22688 4.81436 6.02873 4.98709L4.28431 6.50737C4.19812 6.58236 4.13389 6.67733 4.09793 6.78298C4.06197 6.88864 4.0555 7.00135 4.07916 7.1101L4.09468 7.17678L4.13787 7.34414C4.17634 7.4852 4.23437 7.68397 4.31603 7.92122C4.47798 8.3925 4.73644 9.026 5.12109 9.65887C5.50574 10.2917 5.95382 10.8214 6.30203 11.1901C6.48354 11.3819 6.67309 11.5667 6.87023 11.744L6.92422 11.7915C7.01147 11.8649 7.11725 11.9156 7.23126 11.9387C7.34526 11.9617 7.4636 11.9563 7.57475 11.9229L9.83271 11.2478C10.0893 11.1711 10.364 11.1691 10.6218 11.2418C10.8796 11.3146 11.1086 11.4589 11.2795 11.6562L12.3478 12.8886C12.7932 13.4016 12.7405 14.1556 12.2283 14.6089C10.8287 15.8484 8.90415 16.1029 7.5653 15.0796C5.92462 13.8215 4.5412 12.2878 3.48397 10.5546C2.41898 8.82209 1.70721 6.91499 1.38594 4.93194ZM5.49292 7.19409L6.94109 5.93221C7.3374 5.58676 7.61606 5.13668 7.74135 4.63972C7.86663 4.14276 7.83282 3.62157 7.64425 3.14299L7.05716 1.65541C6.81764 1.04764 6.3432 0.549531 5.73055 0.262636C5.11789 -0.0242588 4.41315 -0.0783456 3.75997 0.111401C1.48919 0.772479 -0.33418 2.70698 0.0518189 5.12366C0.398316 7.26649 1.16686 9.32804 2.3172 11.2003C3.45751 13.0693 4.94958 14.7233 6.71907 16.0798C8.72667 17.6123 11.4084 17.0897 13.1488 15.5476C13.6471 15.1068 13.9494 14.5019 13.9942 13.8564C14.039 13.2108 13.8228 12.5734 13.3897 12.0743L12.3215 10.8419C11.9796 10.4472 11.5214 10.1585 11.0057 10.013C10.49 9.86741 9.94032 9.8716 9.42714 10.025L7.55315 10.5854C7.46925 10.5034 7.38713 10.4199 7.30684 10.3347C6.92157 9.92994 6.58082 9.48886 6.28988 9.01831C6.00633 8.54356 5.77456 8.04254 5.59819 7.52303C5.56073 7.4143 5.52563 7.30484 5.49292 7.19474" fill={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "var(--darkBlue)" : "#6d6d6d"}/>
                            </svg>
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "closeEnqDetails" || closeEnqDetails.emergencyContactNumber ? "10px" : "14px", color: currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Number</p>
                          </div>
                          <input id="emergency-contact-phone" value={closeEnqDetails.emergencyContactNumber} placeholder="Enter Number" onChange={handleChange("emergencyContactNumber")} className={`${currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "active-input-field" : "inactive-input-field"}`} type="number" />
                        </div>
                        <div onClick={toggleInputFields('pan-number')} className={`${currentElementId == "pan-number" || closeEnqDetails.panNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "pan-number" || closeEnqDetails.panNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "48%", marginBottom: window.innerWidth < 768 && "12px" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "pan-number" || closeEnqDetails.panNumber ? "10px" : "14px", color: currentElementId == "pan-number" || closeEnqDetails.panNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>PAN Number</p>
                          </div>
                          <input id="pan-number" value={closeEnqDetails.panNumber} placeholder="Enter PAN No." onChange={handleChange("panNumber")} className={`${currentElementId == "pan-number" || closeEnqDetails.panNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                        </div>
                        <div onClick={toggleInputFields('aadhar-number')} className={`${currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "48%", marginBottom: window.innerWidth < 768 && "12px" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "aadhar-number" || closeEnqDetails.aadharNumber ? "10px" : "14px", color: currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhar Number {membershipBillingConfig?.aadhar == true && <span className="color-red fs-14 font-weight-700" style={{lineHeight:"14px"}}>*</span>}</p>
                          </div>
                          <input id="aadhar-number" value={closeEnqDetails.aadharNumber} placeholder="Enter Aadhar No." onChange={handleChange("aadharNumber")} className={`${currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "active-input-field" : "inactive-input-field"}`} type="number" />
                        </div>
                        <div onClick={toggleInputFields('gstin-number')} className={`${currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "48%"  }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "gstin-number" || closeEnqDetails.gstinNumber ? "10px" : "14px", color: currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>GSTIN Number</p>
                          </div>
                          <input id="gstin-number" value={closeEnqDetails.gstinNumber} placeholder="Enter GSTIN No." onChange={handleChange("gstinNumber")} className={`${currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                        </div>
                        <div onClick={toggleInputFields('invoice-date')} className={`${currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "48%" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "invoice-date" || closeEnqDetails.invoiceDate ? "10px" : "14px", color: currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Invoice Date <span className="color-red fs-14 font-weight-700" style={{lineHeight:"14px"}}>*</span></p>
                          </div>
                          <input id="invoice-date" value={formatDateTime(closeEnqDetails.invoiceDate)} placeholder="DD/MM/YYYY" className={`${currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
                        </div>
                        <div onClick={toggleInputFields('billing-date')} className={`${currentElementId == "billing-date" || closeEnqDetails.billingDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "billing-date" || closeEnqDetails.billingDate ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "32%" : "48%", marginTop: window.innerWidth < 641 && "12px" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "billing-date" || closeEnqDetails.billingDate ? "10px" : "14px", color: currentElementId == "billing-date" || closeEnqDetails.billingDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment Date <span className="color-red fs-14 font-weight-700" style={{lineHeight:"14px"}}>*</span></p>
                          </div>
                          <input id="billing-date" value={formatDateTime(closeEnqDetails.billingDate)} placeholder="DD/MM/YYYY" className={`${currentElementId == "billing-date" || closeEnqDetails.billingDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
                        </div>
                      </div>
                    )
                  }
                </div>

                {
                  (props.type == "upgrade-membership" && props.selectedUsers && props.selectedUsers.membershipplans && props.selectedUsers.membershipplans.length) && (
                    window.innerWidth > 767 ? (
                      <div className="w-full existing-plan-container m-t-12">
                        <p className="flex-item fs-16 font-weight-700 color-dark-blue">Existing Plan Details</p>

                        <div className="flex-item space-between d-flex-wrap m-t-12">
                          <div className="d-flex space-between m-b-12" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">Duration</p>
                            <p className="flex-item color-blue">{props.selectedUsers.membershipplans[0].packages[0].duration} {props.selectedUsers.membershipplans[0].packages[0].durationType}'s</p>
                          </div>

                          <div className="d-flex space-between m-b-12" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">Amount Paid</p>
                            <p className="flex-item color-blue">₹ {amountPaid}</p>
                          </div>

                          <div className="d-flex space-between m-b-12" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">Trainer</p>
                            <p className="flex-item color-blue">{props.selectedUsers.trainer.length ? props.selectedUsers.trainer[0].name : '-' }</p>
                          </div>

                          <div className="d-flex space-between" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">Start Date</p>
                            <p className="flex-item color-blue">{props.selectedUsers.starts_at_string}</p>
                          </div>

                          <div className="d-flex space-between" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">End Date</p>
                            <p className="flex-item color-blue">{props.selectedUsers.ends_at_string}</p>
                          </div>

                          <div className="d-flex space-between" style={{width:"28%"}}>
                            <p className="flex-item font-weight-600">Session</p>
                            <p className="flex-item color-blue">{props.selectedUsers.completed_sessions?props.selectedUsers.completed_sessions:0} / {Number(props.selectedUsers.sessions) + Number(props.selectedUsers?.add_on_days || 0)}</p>
                          </div>
                        </div> 
                      </div>
                    ) : (
                      <div className="w-full m-t-12" style={{background:"#ffffff", borderRadius:"16px", padding:"16px"}}>
                        <p className="flex-item fs-17 font-weight-700 color-dark-blue m-b-16">Existing Plan Details</p>

                        <div className="d-flex w-full m-b-12">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Duration</p>
                          <p className="flex-item font-weight-700 color-dark-blue">{props.selectedUsers.membershipplans[0].packages[0].duration} {props.selectedUsers.membershipplans[0].packages[0].durationType}'s</p>
                        </div>

                        <div className="d-flex w-full m-b-12">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Session</p>
                          <p className="flex-item font-weight-700 color-dark-blue">{props.selectedUsers.completed_sessions?props.selectedUsers.completed_sessions:0} / {Number(props.selectedUsers.sessions) + Number(props.selectedUsers?.add_on_days || 0)}</p>
                        </div>

                        <div className="d-flex w-full m-b-12">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Start Date</p>
                          <p className="flex-item font-weight-700 color-dark-blue">{props.selectedUsers.starts_at_string}</p>
                        </div>

                        <div className="d-flex w-full m-b-12">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>End Date</p>
                          <p className="flex-item font-weight-700 color-dark-blue">{props.selectedUsers.ends_at_string}</p>
                        </div>

                        <div className="d-flex w-full m-b-12">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Trainer</p>
                          <p className="flex-item font-weight-700 color-dark-blue">{props.selectedUsers.trainer.length ? props.selectedUsers.trainer[0].name : '-' }</p>
                        </div>

                        <div className="d-flex w-full">
                          <p className="flex-item" style={{width:"140px", flexShrink:0, color:"#6D6D6D"}}>Amount Paid</p>
                          <p className="flex-item font-weight-700 color-dark-blue">₹ {amountPaid}</p>
                        </div>
                      </div>
                    )
                  )
                }

                {/* MEMBERSHIP PLANS */}

                <div className="enquiry-types-horizontal-scroll-container d-flex" style={{borderTop:"1px dashed #6d6d6d", marginTop:"12px", paddingTop:"12px"}}>
                  {
                    membershipTypes.map((plan, index) => {
                      return (
                        <div onClick={selectMemberShipType(plan)} className={`member-button-global btn-center d-flex m-r-12 ${selectedMembershipType == plan ? "global-blue-button-controller-active" : "member-button-global-inactive"}`} style={{ height:"40px", borderRadius:"20px",pointerEvents:'auto !important' }}>
                          <p className="flex-item fs-12" style={{whiteSpace:"nowrap", fontWeight: selectedMembershipType == plan && "700"}}>{plan}</p>
                        </div>
                      )
                    })
                  }
                </div>

                <div className="d-flex">
                  <div onClick={()=>handleAllowPoolMembership()} className="d-flex m-t-12 m-b-8 p-l-8 p-r-8 p-t-8 p-b-8 cursor-pointer" style={{borderRadius:"12px", backgroundColor: allowPoolMembership ? "#e33a34" : "#ffffff" }}>
                    <input className="flex-item m-r-8" type="checkbox" checked={allowPoolMembership} style={{width:"20px", height:"20px"}} />
                    <p className="flex-item fs-16 font-weight-600" style={{color: allowPoolMembership ? "#ffffff" : "#000000", lineHeight:"16px" }}>Pool Membership</p>
                  </div>
                </div>

                <div className="membership-selection-container m-t-8 flex-item m-b-12" onScroll={handleMembershipScroll} style={{paddingTop:window.innerWidth > 767 && "0px" }}>
                  {
                    window.innerWidth < 768 ? (
                      allMemberships.map((membership, index) => {
                        if (membership.packages && membership.packages.length > 1) {
                          return (
                            <div className="w-full m-b-12" style={{ padding: "8px 6px 0px", borderRadius: "4px", border: "1px dashed #9a9a9a" }}>
                              {
                                membership.packages.map((data, packageIndex) => {
                                  const isSelected = closeEnqDetails.selectedMemberships?.some(
                                    m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id
                                  );
                                  return (
                                    <div className="d-flex space-between m-b-16">
                                      <div onClick={() => handleSelectMembership(membership, packageIndex)} className="d-flex cursor-pointer" style={{ width: isSelected ? "55%" : "100%" }}>
                                        <input type={(props.type == "upgrade-membership" || allowPoolMembership) ? "radio" : "checkbox"} name="mob-membership" style={{ alignSelf: "flex-start", width: "16px", height: "16px" }} checked={isSelected} />
                                        <div className="m-l-8" style={{ alignSelf: "flex-start", width: "90%" }}>
                                          <p className="fs-16 color-dark-blue font-weight-700" style={{ marginTop: "-3px" }}>{membership.name}</p>
                                          <p>Duration - <span className="font-weight-700">{data.duration + " " + data.durationType + "(s)"}</span></p>
                                          <p>Sessions - <span className="font-weight-700">{data.sessions}</span></p>
                                          <p>Rack Rate - <span className="font-weight-700">₹ {data.rackRate}</span></p>
                                          <p>Cost - <span className="font-weight-700">₹ {data.basePrice}</span></p>
                                        </div>
                                      </div>
                                      {
                                        isSelected && (
                                          <div onClick={()=>toggleInputFields('membership-discount')} className={`${currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "17%" : "100%" }}>
                                            <div className="flex-item d-flex">
                                              <svg className="flex-item m-r-6" width={currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "12" : "16"}  height={currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "var(--darkBlue)" : "#6d6d6d"}/>
                                                <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "var(--darkBlue)" : "#6d6d6d"}/>
                                              </svg>
                                              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "10px" : "14px", color: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "var(--darkBlue)" : "", transition: "180ms" }}>Discount <span className="color-red font-weight-700">*</span></p>
                                            </div>
                                            <input id="membership-discount" value={formatDateTime(closeEnqDetails.selectedMemberships[0].endDate)} placeholder="DD/MM/YYYY" onClick={handleChange("membership-discount")} className={`${currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                          </div>
                                        )
                                      }
                                    </div>
                                  )
                                })
                              }
                            </div>
                          )
                        }
                        else {
                          const pkg = membership.packages[0];
                          const isSelectedPackage = closeEnqDetails.selectedMemberships?.some(m => m._id == membership._id && m.packages._id == pkg._id);
                          return (
                            <div className="m-b-12" style={{ paddingBottom: (allMemberships.length != index + 1) && "12px", borderBottom: allMemberships.length != index + 1 && "1px dashed #dcdcdc" }}>
                              <div onClick={() => handleSelectMembership(membership)} className="d-flex cursor-pointer" style={{ width:"100%" }}>
                                {/* <input type={(props.type == "upgrade-membership" || allowPoolMembership) ? "radio" : "checkbox"} name="mob-membership" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} checked={closeEnqDetails.selectedMemberships?.some(m => m._id == membership._id && m.packages._id == membership.packages[0]._id)} /> */}
                                <input type={(props.type == "upgrade-membership" || allowPoolMembership) ? "radio" : "checkbox"} name="mob-membership" style={{ alignSelf: "flex-start", width: "16px", height: "16px" }} checked={isSelectedPackage}/>
                                <div className="m-l-8" style={{ alignSelf: "flex-start", width: "90%" }}>
                                  <p className="fs-16 color-dark-blue font-weight-700" style={{ marginTop: "-3px" }}>{membership.name}</p>
                                  <p>Duration - <span className="font-weight-700">{pkg.duration + " " + pkg.durationType + "(s)"}</span></p>
                                  <p>Sessions - <span className="font-weight-700">{pkg.sessions}</span></p>
                                  <p>Rack Rate - <span className="font-weight-700">₹ {pkg.rackRate}</span></p>
                                  <p>Cost - <span className="font-weight-700">₹ {pkg.basePrice}</span></p>
                                </div>
                              </div>
                              {
                                isSelectedPackage && (
                                  <div onClick={toggleInputFields('membership-discount')} className={`${currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == pkg._id)?.membershipDiscount ? "member-global-input-field" : "member-global-input-field d-flex"} w-full m-t-12 m-l-24`} style={{border: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == pkg._id)?.membershipDiscount ? "1px solid var(--darkBlue)" : "", alignSelf: "flex-start", width: "200px"}}>
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{fontSize: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == pkg._id)?.membershipDiscount ? "10px" : "14px", color: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == pkg._id)?.membershipDiscount ? "var(--darkBlue)" : "#4d4d4d"}} >Discount (₹)</p>
                                    </div>
                                    {
                                      currentElementId == "membership-discount" && (
                                        <div onClick={(e)=>e.stopPropagation()} className="d-flex flex-item">
                                          <input className="flex-item" id="membership-discount" value={closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == pkg._id)?.membershipDiscount || ''} placeholder="0.0" onChange={handleChange("membershipDiscount", null, membership._id)} style={{ width: "60%" }} type="text"/>                                            
                                        </div>
                                      )
                                    }
                                  </div>
                                )
                              }
                            </div>
                          )
                        }
                        allMemberships.length != index + 1 && (
                          <div className="margin-auto m-t-12 m-b-12" style={{width:"100%", height:"1.5px", background:"#ffffff"}} />
                        )
                      })
                    ) : (
                      <div className="w-full">
                        <div className="d-flex w-full space-between m-b-12" style={{padding:"8px 6px 8px 0px", background:"#EFFAFF", position:"sticky", top:0, borderRadius:"8px 8px 0 0", borderBottom:"1px solid #cecece", zIndex:2}}>
                          <p className="flex-item fs-14 font-weight-700 color-dark-blue" style={{width:"36%"}}>Name</p>
                          <div className="flex-item" style={{width:"14%", textAlign:"center"}}>
                            <p className="fs-14 font-weight-700 color-dark-blue">Duration</p>
                          </div>
                          <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                            <p className="fs-14 font-weight-700 color-dark-blue">Sessions</p>
                          </div>
                          <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                            <p className="fs-14 font-weight-700 color-dark-blue">Cost</p>
                          </div>
                          <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                            <p className="fs-14 font-weight-700 color-dark-blue">Base Price</p>
                          </div>
                          <div className="flex-item" style={{width:"12%", textAlign:"center"}}>
                            <p className="fs-14 font-weight-700 color-dark-blue">Discount</p>
                          </div>
                        </div>

                        {
                          allMemberships.map((membership, index) => {
                            if(membership.packages && membership.packages.length > 1){
                              return(
                                <div className="w-full m-b-12" style={{padding:"8px 6px 0px", borderRadius:"4px", border:"1px dashed #9a9a9a"}}>
                                  {
                                    membership.packages.map((data, packageIndex) => {
                                      return(
                                        <div className="d-flex w-full space-between m-b-16 cursor-pointer">
                                          <div onClick={()=>handleSelectMembership(membership,packageIndex)} className="d-flex p-t-4" style={{width:"36%", alignSelf:"flex-start"}}>
                                            <input type={(props.type == "upgrade-membership" || allowPoolMembership) ? "radio" : "checkbox"} name="membership" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} checked={closeEnqDetails.selectedMemberships?.some(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)} />
                                            <div className="m-l-8" style={{alignSelf:"flex-start", width:"90%"}}>
                                              <p className="fs-16 color-dark-blue font-weight-700" style={{marginTop:"-3px"}}>{membership.name}</p>
                                            </div>
                                          </div>
                                          <div className="p-t-4" style={{width:"14%", textAlign:"center",  alignSelf:"flex-start"}}>
                                            <p><span className="font-weight-700">{data.duration + " " + data.durationType+"(s)" }</span></p>
                                          </div>
                                          <div className="p-t-4" style={{width:"13%", textAlign:"center",  alignSelf:"flex-start"}}>
                                            <p><span className="font-weight-700">{data.sessions}</span></p>
                                          </div>
                                          <div className="p-t-4" style={{width:"13%", textAlign:"center", alignSelf:"flex-start"}}>
                                            <p><span className="font-weight-700">₹ {data.rackRate}</span></p>
                                          </div>
                                          <div className="p-t-4" style={{width:"13%", textAlign:"center", alignSelf:"flex-start"}}>
                                            <p><span className="font-weight-700">₹ {data.basePrice}</span></p>
                                          </div>
                                          <div style={{width:"12%", textAlign:"center", alignSelf:"flex-start"}}>
                                          {
                                            closeEnqDetails.selectedMemberships?.some(
                                              m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id
                                            ) && (
                                              <div
                                                className="member-global-input-field d-flex w-full"
                                                style={{
                                                  border: currentElementId == "membership-discount" || closeEnqDetails.selectedMemberships.find(m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id)?.membershipDiscount
                                                    ? "1px solid var(--darkBlue)"
                                                    : "",
                                                  alignSelf: "flex-start",
                                                  height: "30px"
                                                }}
                                              >
                                                <p className="flex-item m-r-4">₹</p>
                                                <input
                                                  className="flex-item"
                                                  id="membership-discount"
                                                  value={
                                                    closeEnqDetails.selectedMemberships.find(
                                                      m => m._id == membership._id && m.packages._id == membership.packages[packageIndex]._id
                                                    )?.membershipDiscount || ''
                                                  }
                                                  placeholder="0.0"
                                                  onChange={handleChange("membershipDiscount", null, membership._id)}
                                                  style={{ width: "90%", textAlign: "center" }}
                                                  type="text"
                                                />
                                              </div>
                                            )
                                          }
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              )
                            }
                            else{
                              return(
                                <div className="d-flex w-full space-between m-b-12" style={{padding:"0 6px 12px 6px", paddingBottom: (allMemberships.length != index + 1) && "12px", borderBottom: allMemberships.length != index + 1 && "1px dashed #dcdcdc"}}>
                                  <div onClick={()=>handleSelectMembership(membership)} className="d-flex cursor-pointer p-t-4" style={{width:"36%", alignSelf:"flex-start"}}>
                                    <input type={(props.type == "upgrade-membership" || allowPoolMembership) ? "radio" : "checkbox"} name="membership" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} checked={closeEnqDetails.selectedMemberships?.some(m => m._id == membership._id && m.packages._id == membership.packages[0]._id)} />
                                    <div className="m-l-8" style={{alignSelf:"flex-start", width:"90%"}}>
                                      <p className="fs-16 color-dark-blue font-weight-700" style={{marginTop:"-3px"}}>{membership.name}</p>
                                    </div>
                                  </div>
                                  <div className="p-t-4" style={{width:"14%", textAlign:"center", alignSelf:"flex-start"}}>
                                    <p><span className="font-weight-700">{membership.packages.length && membership.packages[0].duration + " " + membership.packages[0].durationType+"(s)" }</span></p>
                                  </div>
                                  <div className="p-t-4" style={{width:"13%", textAlign:"center", alignSelf:"flex-start"}}>
                                    <p><span className="font-weight-700">{membership.packages.length && membership.packages[0].sessions}</span></p>
                                  </div>
                                  <div className="p-t-4" style={{width:"13%", textAlign:"center", alignSelf:"flex-start"}}>
                                    <p><span className="font-weight-700">₹ {membership.packages.length && membership.packages[0].rackRate}</span></p>
                                  </div>
                                  <div className="p-t-4" style={{width:"13%", textAlign:"center", alignSelf:"flex-start"}}>
                                    <p><span className="font-weight-700">₹ {membership.packages.length && membership.packages[0].basePrice}</span></p>
                                  </div>
                                  <div style={{width:"12%", textAlign:"center"}}>
                                    {
                                      closeEnqDetails.selectedMemberships?.some(m => m._id == membership._id && m.packages._id == membership.packages[0]._id) && (                                
                                        <div className={`${currentElementId == "membership-discount" || closeEnqDetails.membership.membershipDiscount ? "member-global-input-field" : "member-global-input-field"} d-flex w-full`} style={{ border: currentElementId == "membership-discount" || closeEnqDetails.membership.membershipDiscount ? "1px solid var(--darkBlue)" : "", alignSelf:"flex-start", height:"30px" }}>
                                          <p className="flex-item m-r-4">₹</p>
                                          <input className="flex-item" id="membership-discount"
                                          value={
                                            closeEnqDetails.selectedMemberships.find(
                                              m => m._id == membership._id && m.packages._id == membership.packages[0]._id
                                            )?.membershipDiscount || ''
                                          } placeholder="0.0" onChange={handleChange("membershipDiscount", null, membership._id)} style={{width:"90%", textAlign:"center"}} type="text" />
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                              )
                            }
                          })
                        }
                      </div>
                    )
                  }
                  {isMemberShipSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                </div>
                <div className="d-flex-wrap space-between">
                  <div onClick={toggleInputFields('trainer')} className={`${currentElementId == "trainer" || closeEnqDetails.selectedTrainer ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width: closeEnqDetails.selectedMemberships && closeEnqDetails.selectedMemberships.length > 1 && window.innerWidth > 767 ? "49%" : window.innerWidth > 767 ? "30%" : "100%" }}>
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <svg className="flex-item m-r-4" width={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "14" : "24"} height={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"}/>
                            </svg>
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "10px" : "16px", lineHeight: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "10px" : "16px", color: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Trainer {closeEnqDetails.selectedMemberships.length > 0 && closeEnqDetails.selectedMemberships.some(m => m.type == "PersonalTraining") ? <span className="color-red font-weight-700">*</span> : ""}</p>
                          </div>

                          <input readOnly id="trainer" value={closeEnqDetails.selectedTrainer ? closeEnqDetails.selectedTrainer.name : ""} type="text" className={`${(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Trainer" style={{ marginTop: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "6px" : "" }} />
                        </div>

                        <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" style={{ transform: currentElementId == "trainer" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>

                        {
                            currentElementId == "trainer" && (
                              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>

                                {/* SEARCH BAR */}
                                <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0, zIndex:2}}>
                                  <div className="search-container d-flex space-between" style={{width:"100%", background:"#ffffff"}}>
                                    <div className="d-flex w-full">
                                      <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                      <input
                                        type="text"
                                        autoFocus
                                        value={trainerSearchKey}
                                        onChange={(e) => setTrainerSearchKey(e.target.value)}
                                        placeholder={`Search Trainer by "Name"`}
                                        className="flex-item search-input"
                                        style={{width:"85%"}}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* LIST */}
                                <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                  {
                                    filteredTrainers.map((trainer, index) => {
                                      return (
                                        <div key={trainer._id || index} onClick={()=>selectTrainer(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                                          {
                                            trainer.profileID ? (
                                              <div className="pt-trainer-profile d-flex m-r-8">
                                                <img className="flex-item margin-auto" src={`${config.API_URL}/image/file/${trainer.profileID}/auto/auto/70`} />
                                              </div>
                                            ) : (
                                              <div className="pt-trainer-profile d-flex m-r-8" style={{ backgroundColor: '#5d883c' }}>
                                                <p className='flex-item' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>
                                                  {`${trainer.name}`.trim()[0]}
                                                </p>
                                              </div>
                                            )
                                          }
                                          <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{trainer.name}</p>
                                        </div>
                                      )
                                    })
                                  }
                                  {filteredTrainers.length === 0 && (
                                    <p className="color-grey-04 fs-14" style={{padding:"12px", textAlign:"center"}}>No trainer found</p>
                                  )}
                                </div>
                              </div>
                            )
                          }
                      </div>
                    </div>
                                        
                    
                  
                  <div onClick={toggleInputFields('handled-by')} className={`${currentElementId == "handled-by" || closeEnqDetails.selectedHandler ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "1px solid var(--darkBlue)" : "", width: closeEnqDetails.selectedMemberships && closeEnqDetails.selectedMemberships.length > 1 && window.innerWidth > 767 ? "49%" : window.innerWidth > 767 ? "30%" : "100%" }}>
                    <div className='d-flex w-full space-between'>
                      <div className='flex-item'>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-4" width={(currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "14" : "24"} height={(currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "var(--darkBlue)" : "#6d6d6d"}/>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "10px" : "16px", lineHeight: (currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "10px" : "16px", color: (currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "var(--darkBlue)" : "", transition: "180ms" }}>Handled By</p>
                        </div>

                        <input readOnly id="handled-by" value={closeEnqDetails.selectedHandler ? closeEnqDetails.selectedHandler.name : ""} type="text" className={`${(currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Employee" style={{ marginTop: (currentElementId == "handled-by" || closeEnqDetails.selectedHandler) ? "6px" : "" }} />
                      </div>

                      <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                        <svg className="flex-item" style={{ transform: currentElementId == "handled-by" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                        </svg>
                      </div>
                                    

                                      
                      {
                          currentElementId == "handled-by" && (
                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>

                              {/* SEARCH BAR */}
                              <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0, zIndex:2}}>
                                <div className="search-container d-flex space-between" style={{width:"100%", background:"#ffffff"}}>
                                  <div className="d-flex w-full">
                                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <input
                                      type="text"
                                      autoFocus
                                      value={handlerSearchKey}
                                      onChange={(e) => setHandlerSearchKey(e.target.value)}
                                      placeholder={`Search Employee by "Name"`}
                                      className="flex-item search-input"
                                      style={{width:"85%"}}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* LIST */}
                              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                {
                                  filteredHandlers.map((handler, index) => {
                                    return (
                                      <div key={handler._id || index} onClick={()=>selectHandler(handler)} className="global-input-field-arrow-dropdown-item d-flex">
                                        {
                                          handler.profileID ? (
                                            <div className="pt-trainer-profile d-flex m-r-8">
                                              <img className="flex-item margin-auto" src={`${config.API_URL}/image/file/${handler.profileID}/auto/auto/70`} />
                                            </div>
                                          ) : (
                                            <div className="pt-trainer-profile d-flex m-r-8" style={{ backgroundColor: '#5d883c' }}>
                                              <p className='flex-item' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>
                                                {`${handler.name}`.trim()[0]}
                                              </p>
                                            </div>
                                          )
                                        }
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{handler.name}</p>
                                      </div>
                                    )
                                  })
                                }
                                {filteredHandlers.length === 0 && (
                                  <p className="color-grey-04 fs-14" style={{padding:"12px", textAlign:"center"}}>No employee found</p>
                                )}
                              </div>
                            </div>
                          )
                        }
                    </div>
                  </div>
                      
                  {
                    closeEnqDetails.selectedMemberships && closeEnqDetails.selectedMemberships.length < 2 && (
                      <div onClick={`${props?.type}` == "upgrade-membership" ?()=> alert("cannot change start date for membership upgrade") : toggleInputFields('enq-closing-date')} className={`${currentElementId == "enq-closing-date" || closeEnqDetails.date ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "enq-closing-date" || closeEnqDetails.date ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && closeEnqDetails.selectedMemberships.length == 1 ? "17%" : window.innerWidth > 767 ? "36%" : "100%" }}>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-6" width={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "12" : "16"}  height={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                            <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "enq-closing-date" || closeEnqDetails.date ? "10px" : "14px", color: currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "", transition: "180ms" }}>Start Date <span className="color-red font-weight-700">*</span></p>
                        </div>
                        <input id="enq-closing-date" value={props.type == "upgrade-membership" ? props.selectedUsers.starts_at_string : formatDateTime(closeEnqDetails.date)} placeholder="DD/MM/YYYY" onChange={handleChange("date")} className={`${currentElementId == "enq-closing-date" || closeEnqDetails.date ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                    )
                  }

                  {
                    closeEnqDetails.selectedMemberships.length == 1 && (
                      <div onClick={toggleInputFields('membership-end-date')} className={`${currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "17%" : "100%" }}>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-6" width={currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "12" : "16"}  height={currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "var(--darkBlue)" : "#6d6d6d"}/>
                            <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "var(--darkBlue)" : "#6d6d6d"}/>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "10px" : "14px", color: currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "var(--darkBlue)" : "", transition: "180ms" }}>End Date <span className="color-red font-weight-700">*</span></p>
                        </div>
                        <input id="membership-end-date" value={formatDateTime(closeEnqDetails.selectedMemberships[0].endDate)} placeholder="DD/MM/YYYY" onClick={handleChange("membership-end-date")} className={`${currentElementId == "membership-end-date" || closeEnqDetails.selectedMemberships.length == 1 ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                    )
                  }
                </div>

               {
                  allowPoolMembership && closeEnqDetails?.selectedMemberships?.length == 1 && closeEnqDetails?.selectedMemberships?.[0]?.packages?.poolMembership == true && poolMembership(closeEnqDetails.selectedMemberships[0],0)
                }

                {
                  closeEnqDetails.selectedMemberships && closeEnqDetails.selectedMemberships.length > 0 && [
                    window.innerWidth < 641 && (
                      <p className="flex-item fs-16 m-b-12 color-red font-weight-700" style={{marginTop:"8px"}}>Selected Memberships</p>
                    ),
                    <div className="w-full m-t-6">
                      {
                        closeEnqDetails.selectedMemberships.length > 1 && (
                          <div className="w-full membership-selected-container m-b-12">
                            {
                              window.innerWidth > 640 && (
                                <div className="d-flex w-full space-between m-b-12" style={{padding:"10px 6px 8px 0px", background:"#fff9ef", position:"sticky", top:0, borderRadius:"8px 8px 0 0", borderBottom:"1px solid #e0e0e0", zIndex:2}}>
                                  <div style={{alignSelf:"flex-start", width:"35%"}}>
                                    <p className="fs-14 color-dark-blue font-weight-700">Selected Memberships</p>
                                  </div>
                                  <div className="flex-item" style={{width:"14%", textAlign:"center"}}>
                                    <p className="fs-14 font-weight-700 color-dark-blue">Duration</p>
                                  </div>
                                  <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                                    <p className="fs-14 font-weight-700 color-dark-blue">Sessions</p>
                                  </div>
                                  <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                                    <p className="fs-14 font-weight-700 color-dark-blue">Cost</p>
                                  </div>
                                  <div className="flex-item" style={{width:"13%", textAlign:"center"}}>
                                    <p className="fs-14 font-weight-700 color-dark-blue">Base Price</p>
                                  </div>
                                  <div className="flex-item" style={{width:"12%", textAlign:"center"}}>
                                    <p className="fs-14 font-weight-700 color-dark-blue">Discount</p>
                                  </div>
                                </div>
                              ) 
                            }
                          
                            {
                              closeEnqDetails.selectedMemberships.map((m,index) => {
                                return(
                                  <div className="w-full">
                                    <div className="d-flex-wrap w-full space-between" style={{padding: window.innerWidth < 641 ? "6px 6px 16px 0px" : "0px 6px 0px 0px", marginBottom: (closeEnqDetails.selectedMemberships.length != index + 1 || m.packages?.poolMembership == true) &&  window.innerWidth > 640 ? "16px" : (closeEnqDetails.selectedMemberships.length != index + 1 || m.packages?.poolMembership == true) && window.innerWidth < 641 ? "8px" : "", borderBottom: window.innerWidth < 641 && "1px solid #a7946b"}}>                            
                                      <div className="flex-item d-flex cursor-pointer" style={{alignSelf:"flex-start", width: window.innerWidth > 640 ? "35%" : "100%", marginBottom: window.innerWidth < 641 && "12px"}}>
                                        {/* <svg className="flex-item m-r-12" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M2.616 15.77C2.168 15.77 1.78667 15.6127 1.472 15.298C1.15733 14.9833 1 14.6023 1 14.155V1.77H0V0.77H4V0H10V0.77H14V1.77H13V14.155C13 14.615 12.846 14.9993 12.538 15.308C12.23 15.6167 11.8453 15.7707 11.384 15.77H2.616ZM12 1.77H2V14.155C2 14.3343 2.05767 14.4817 2.173 14.597C2.28833 14.7123 2.436 14.77 2.616 14.77H11.385C11.5383 14.77 11.6793 14.706 11.808 14.578C11.9367 14.45 12.0007 14.3087 12 14.154V1.77ZM4.808 12.77H5.808V3.77H4.808V12.77ZM8.192 12.77H9.192V3.77H8.192V12.77Z" fill="#CC0000"/>
                                        </svg> */}
                                        <p className="font-weight-500 m-r-6 fs-16" style={{alignSelf:"flex-start"}}>{index + 1}.</p>
                                        <div className="cursor-pointer" style={{alignSelf:"flex-start", width:"96%"}}>
                                          <p className="color-dark-blue font-weight-700 fs-16 m-b-6">{m.name}</p>

                                               
                                          {
                                            membershipEditIndex == index && editDateType == "start" ? (
                                              <div onClick={(e)=>e.stopPropagation()} className="flex-item d-flex w-full m-t-4 m-b-12">
                                                <input id={`temp-start-date-`+index} className="flex-item m-r-12" value={tempMembershipDate != "" ? formatDateTime(tempMembershipDate) : formatDateTime(m.startDate)} onClick={handleChange(`temp-start-date-`+index)} placeholder="DD/MM/YYYY" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"100px", height:"30px", color:"#5d883c", textAlign:"center", fontWeight:"700"}} type="number" />
                                                <div onClick={()=>toggleMembershipDate("cancel", "start")} className="flex-item d-flex cursor-pointer" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                                  <svg className="flex-item margin-auto" width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 14L14 1M14 14L1 1" stroke="#E33A34" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                  </svg>
                                                </div>
                                                <div onClick={()=>toggleMembershipDate("save", "start")} className="flex-item d-flex cursor-pointer m-l-12" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                                  <svg className="flex-item margin-auto" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 6.08696L4.48387 10L13 1" stroke="#03AA00" stroke-width="2" stroke-linecap="round"/>
                                                  </svg>
                                                </div>
                                              </div>
                                            ) : (
                                              <div onClick={()=>handleEditMembershipDate(index, "start")} className="flex-item d-flex w-full m-b-8">
                                                <div className="fs-13 m-r-6 font-weight-700 d-flex flex-item" style={{maxWidth:"96%"}}><p className="flex-item" style={{width:"70px"}}>Starts At :</p> <p className="flex-item color-blue" style={{width:"80px"}}>{formatDateTime(m.startDate)}</p></div>
                                                <svg className="flex-item" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M10.92 0.847C11.4801 0.299809 12.2334 -0.00450926 13.0164 5.05113e-05C13.7994 0.00461028 14.549 0.31768 15.1027 0.871357C15.6564 1.42503 15.9694 2.17467 15.974 2.95768C15.9785 3.74068 15.6742 4.49391 15.127 5.054L14.458 5.723L10.251 1.516L10.92 0.847ZM9.54403 2.224L1.54503 10.223C1.2178 10.5508 0.990621 10.9649 0.890033 11.417L0.012033 15.367C-0.00633093 15.4492 -0.0036392 15.5347 0.0198586 15.6155C0.0433565 15.6964 0.086899 15.77 0.146447 15.8296C0.205994 15.8891 0.279617 15.9327 0.360485 15.9562C0.441354 15.9797 0.526847 15.9824 0.609033 15.964L4.53503 15.091C5.00283 14.9879 5.43115 14.7526 5.76903 14.413L13.751 6.431L9.54403 2.224Z" fill="#E33A34"/>
                                                </svg>
                                              </div>
                                            )
                                          }
                                          
                                          {
                                            membershipEditIndex == index && editDateType == "end" ? (
                                              <div onClick={(e)=>e.stopPropagation()} className="flex-item d-flex w-full m-t-4">
                                                <input id={`temp-end-date-`+index} className="flex-item m-r-12" value={tempMembershipDate != "" ? formatDateTime(tempMembershipDate) : formatDateTime(m.endDate)} onClick={handleChange(`temp-end-date-`+index)} placeholder="DD/MM/YYYY" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"100px", height:"30px", color:"#5d883c", textAlign:"center", fontWeight:"700"}} type="number" />
                                                <div onClick={()=>toggleMembershipDate("cancel", "end")} className="flex-item d-flex cursor-pointer" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                                  <svg className="flex-item margin-auto" width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 14L14 1M14 14L1 1" stroke="#E33A34" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                  </svg>
                                                </div>
                                                <div onClick={()=>toggleMembershipDate("save", "end")} className="flex-item d-flex cursor-pointer m-l-12" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                                  <svg className="flex-item margin-auto" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 6.08696L4.48387 10L13 1" stroke="#03AA00" stroke-width="2" stroke-linecap="round"/>
                                                  </svg>
                                                </div>
                                              </div>
                                            ) : (
                                              <div onClick={()=>handleEditMembershipDate(index, "end")} className="flex-item d-flex w-full">
                                                <div className="fs-13 m-r-6 font-weight-700 d-flex flex-item"><p className="flex-item" style={{width:"70px"}}>Ends At :</p> <p className="flex-item color-blue" style={{width:"80px"}}>{formatDateTime(m.endDate)}</p></div>
                                                <svg className="flex-item" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M10.92 0.847C11.4801 0.299809 12.2334 -0.00450926 13.0164 5.05113e-05C13.7994 0.00461028 14.549 0.31768 15.1027 0.871357C15.6564 1.42503 15.9694 2.17467 15.974 2.95768C15.9785 3.74068 15.6742 4.49391 15.127 5.054L14.458 5.723L10.251 1.516L10.92 0.847ZM9.54403 2.224L1.54503 10.223C1.2178 10.5508 0.990621 10.9649 0.890033 11.417L0.012033 15.367C-0.00633093 15.4492 -0.0036392 15.5347 0.0198586 15.6155C0.0433565 15.6964 0.086899 15.77 0.146447 15.8296C0.205994 15.8891 0.279617 15.9327 0.360485 15.9562C0.441354 15.9797 0.526847 15.9824 0.609033 15.964L4.53503 15.091C5.00283 14.9879 5.43115 14.7526 5.76903 14.413L13.751 6.431L9.54403 2.224Z" fill="#E33A34"/>
                                                </svg>
                                              </div>
                                            )
                                          }
                                        </div>
                                      </div>
                                      <div className="flex-item m-t-4" style={{width: window.innerWidth > 640 ? "14%" : "100%", textAlign: window.innerWidth > 640 && "center", marginLeft: window.innerWidth < 641 && "20px", alignSelf:"flex-start"}}>
                                        <p><span className="font-weight-700 fs-15">{window.innerWidth < 641 && "Duration -"} {m.packages.duration + " " + m.packages.durationType+"(s)"}</span></p>
                                      </div>
                                      <div className="flex-item m-t-4" style={{width: window.innerWidth > 640 ? "13%" : "100%", textAlign: window.innerWidth > 640 && "center", marginLeft: window.innerWidth < 641 && "20px", alignSelf:"flex-start"}}>
                                        <p><span className="font-weight-700 fs-15">{window.innerWidth < 641 && "Sessions -"} {m.packages.sessions}</span></p>
                                      </div>
                                      <div className="flex-item m-t-4" style={{width: window.innerWidth > 640 ? "13%" : "100%", textAlign: window.innerWidth > 640 &&  "center", marginLeft: window.innerWidth < 641 && "20px", alignSelf:"flex-start"}}>
                                        <p><span className="font-weight-700 fs-15">{window.innerWidth < 641 && "Rack Rate -"} ₹ {m.packages.rackRate}</span></p>
                                      </div>
                                      <div className="flex-item m-t-4" style={{width: window.innerWidth > 640 ? "13%" : "100%", textAlign: window.innerWidth > 640 &&  "center", marginLeft: window.innerWidth < 641 && "20px", alignSelf:"flex-start",  marginBottom: window.innerWidth < 641 && "12px"}}>
                                        <p><span className="font-weight-700 fs-15">{window.innerWidth < 641 && "Base Price -"} ₹ {m.packages.basePrice}</span></p>
                                      </div>
                                      <div className="flex-item" style={{width: window.innerWidth > 640 ? "12%" : "100px", textAlign: window.innerWidth > 640 && "center", marginLeft: window.innerWidth < 641 && "20px", alignSelf:"flex-start"}}>
                                        <div className="member-global-input-field d-flex w-full" style={{ border: "1px solid var(--darkBlue)", alignSelf:"flex-start", height:"30px" }}>
                                          <p className="flex-item m-r-4">₹</p>
                                          <input className="flex-item" id="membership-discount" value={m.membershipDiscount} placeholder="0.0" onChange={handleChange("membershipDiscount", null, m._id)} style={{width:"90%", textAlign: window.innerWidth > 640 && "center"}} type="text" />
                                        </div>
                                      </div>
                                    </div>

                                    {
                                      allowPoolMembership && m.packages?.poolMembership == true && poolMembership(m, index)
                                    }
                                  </div>
                                )
                              })
                            }
                          </div>
                        )
                      }

                      <div className="w-full d-flex-wrap space-between p-t-12" style={{borderTop:"1px dashed #9a9a9a"}}>

                        {/* PAYMENT MODE */}
                        <div className="space-between d-flex" style={{width: window.innerWidth > 767 ? "48%" : "100%", height: window.innerWidth > 767 && "67%", flexDirection: "column", alignSelf: window.innerWidth > 767 && "flex-start"}}>
                          <div className="w-full" style={{alignSelf:"flex-start"}}>
                            <div className="w-full d-flex">
                              <p className={`${window.innerWidth < 768 ? "margin-auto fs-16" : "fs-18"} font-weight-700 color-dark-blue m-b-8`}>Payment Mode</p>
                            </div>

                            <div onClick={toggleInputFields("payment-mode")} className={`${currentElementId == "payment-mode" || closeEnqDetails.paymentMode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "payment-mode" || closeEnqDetails.paymentMode) ? "1px solid var(--darkBlue)" : "", height:"auto", height:"50px", width:"100%" }}>
                              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "payment-mode" || closeEnqDetails.paymentMode) ? "4px" : ""}}>
                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "payment-mode" || closeEnqDetails.paymentMode) ? "10px" : "16px", lineHeight: (currentElementId == "payment-mode" || closeEnqDetails.paymentMode) ? "10px" : "16px", color: (currentElementId == "payment-mode" || closeEnqDetails.paymentMode) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment Mode</p>
                              </div>
                              <div className='input-field-arrow-dropdown' style={{ margin: "14px 12px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" style={{ transform: currentElementId == "payment-mode" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                              <p id="payment-mode" className={`flex-item fs-16 ${(currentElementId == "payment-mode") ? "active-input-field color-grey-04" : closeEnqDetails.paymentMode ? "active-input-field" : "inactive-input-field"}`} style={{marginTop:"24px"}}>{closeEnqDetails.paymentMode ? closeEnqDetails.paymentMode : "Enter Card Type"}</p>
                              
                              {
                                currentElementId == "payment-mode" && (
                                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : closeEnqDetails.paymentMode && "56px"}}>
                                    <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                      {
                                        paymentModes.map((data, index) => {
                                          if (data === "Razorpay" && user.role !== 0) {
                                            return null;
                                          }

                                          return (
                                            <div onClick={handlePaymentMode(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                              <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                )
                              }
                            </div>



                            {/* <div className="d-flex flex-item w-full space-between m-b-12">
                              <div onClick={handlePaymentMode("Online")} className="flex-item d-flex">
                                <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Online"} style={{width:"auto"}} />
                                <p className={`${closeEnqDetails.paymentMode == "Online" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Online</p>
                              </div>
                              <div onClick={handlePaymentMode("Card")} className="flex-item d-flex">
                                <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Card"} style={{width:"auto"}}/>
                                <p className={`${closeEnqDetails.paymentMode == "Card" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Card</p>
                              </div>
                              <div onClick={handlePaymentMode("Cheque")} className="flex-item d-flex">
                                <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Cheque"} style={{width:"auto"}}/>
                                <p className={`${closeEnqDetails.paymentMode == "Cheque" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Cheque</p>
                              </div>
                              <div onClick={handlePaymentMode("Cash")} className="flex-item d-flex">
                                <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Cash"} style={{width:"auto"}}/>
                                <p className={`${closeEnqDetails.paymentMode == "Cash" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Cash</p>
                              </div>
                              <div onClick={handlePaymentMode("Other")} className="flex-item d-flex">
                                <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Other"} style={{width:"auto"}}/>
                                <p className={`${closeEnqDetails.paymentMode == "Other" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Other</p>
                              </div>
                            </div> */}

                            {
                              (closeEnqDetails.paymentMode == "Razorpay" && razorpayInfo == null) && (
                                <div onClick={()=>closeEnqDetails.amountPaid > 0 && generateRazorpayPaymentLink(props.selectedUsers)} className="w-full payment-generation" style={{backgroundColor: closeEnqDetails.amountPaid == 0 && "#9a9a9a"}}>
                                  <p>Generate Payment Link of</p>
                                  <p className="fs-26 m-t-8" style={{lineHeight:"26px"}}>₹ {closeEnqDetails.amountPaid && closeEnqDetails.amountPaid > 0 ? closeEnqDetails.amountPaid : "0.0"}</p>
                                </div>
                              )
                            }

                            {
                              paymentStatus != null && (
                                <div className="w-full">
                                  <div className="member-global-input-field flex-item m-b-12" style={{ border: "1px solid var(--darkBlue)", width:"100%"}}>
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{ fontSize:"10px", color: "var(--darkBlue)", transition: "180ms" }}>Payment ID</p>
                                    </div>
                                    <div className="active-input-field d-flex m-t-22">
                                      <input className="flex-item" id="cheque-number" value={paymentStatus?.razorPay?.razorpayPaymentId} style={{width:"100%"}} type="text" />
                                    </div>
                                  </div>
                                  <div className="member-global-input-field flex-item m-b-12" style={{ border: "1px solid var(--darkBlue)", width:"100%"}}>
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{ fontSize:"10px", color: "var(--darkBlue)", transition: "180ms" }}>Order ID</p>
                                    </div>
                                    <div className="active-input-field d-flex m-t-22">
                                      <input className="flex-item" id="cheque-number" value={paymentStatus?.razorPay?.razorpayOrderId} style={{width:"100%"}} type="text" />
                                    </div>
                                  </div>
                                </div>
                              )
                            }

                            {
                                (closeEnqDetails.paymentMode == "Online" || closeEnqDetails.paymentMode == "Wallet") && (
                                  <div className="w-full">
                                    <div onClick={toggleInputFields('paymentSource')} className={`${currentElementId == "paymentSource" || closeEnqDetails.paymentSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "1px solid var(--darkBlue)" : "", height: "auto", minHeight: "54px", width: "100%" }}>
                                      <div className='d-flex w-full space-between'>
                                        <div className='flex-item'>
                                          <div className="flex-item d-flex">
                                            <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                            </svg>
                                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                                          </div>

                                          <input readOnly id="paymentSource" value={closeEnqDetails.paymentSource || ""} type="text" className={`${(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "active-input-field" : "inactive-input-field"}`} placeholder="Payment is done via" style={{ marginTop: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "6px" : "" }} />
                                        </div>

                                        <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                          <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                                          </svg>
                                        </div>

                                        {
                                          currentElementId == "paymentSource" && (
                                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", padding: "0"}}>
                                              {
                                                closeEnqDetails.paymentMode == "Online" && (
                                                  <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                                    {
                                                      paymentSources.online.map((data, index) => {
                                                        return (
                                                          <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                            <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                          </div>
                                                        )
                                                      })
                                                    }
                                                  </div>
                                                )
                                              }

                                              {
                                                (closeEnqDetails.paymentMode == "Card" || closeEnqDetails.paymentMode == "Wallet") && (
                                                  <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                                    {
                                                      paymentSources.wallet.map((data, index) => {
                                                        return (
                                                          <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                            <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                          </div>
                                                        )
                                                      })
                                                    }
                                                  </div>
                                                )
                                              }
                                            </div>
                                          )
                                        }
                                      </div>
                                    </div>
                                  </div>
                                )
                              }


                            {
                              (closeEnqDetails.paymentMode == "Card") && (
                                <div className="w-full">
                                  <div onClick={toggleInputFields("card-type")} className={`${currentElementId == "card-type" || closeEnqDetails.cardType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                                      <div className='d-flex w-full space-between'>
                                        <div className='flex-item'>
                                          <div className="flex-item d-flex">
                                            <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                            </svg>
                                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Type</p>
                                          </div>

                                          <input readOnly id="card-type" value={closeEnqDetails.cardType || ""} type="text" className={`${(currentElementId == "card-type" || closeEnqDetails.cardType) ? "active-input-field" : "inactive-input-field"}`} placeholder="Enter Card Type" style={{ marginTop: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "6px" : "" }} />
                                        </div>

                                        <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                          <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                          </svg>
                                        </div>

                                        {
                                          currentElementId == "card-type" && (
                                            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                                              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                                {
                                                  cardTypes.map((data, index) => {
                                                    return (
                                                      <div onClick={()=>handleSelectCard(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                      </div>
                                                    )
                                                  })
                                                }
                                              </div>
                                            </div>
                                          )
                                        }
                                      </div>
                                    </div>
                                  
                                  <div 
                                    onClick={toggleInputFields('approved-code')} 
                                    className={`${currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full`} 
                                    style={{ border: currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "1px solid var(--darkBlue)" : "" }}
                                  >
                                    <div className="flex-item d-flex">
                                      <p 
                                        className="placeholder-txt flex-item" 
                                        style={{ 
                                          fontSize: currentElementId === "approved-code" || closeEnqDetails.approvedCode ? "10px" : "14px", 
                                          color: currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "var(--darkBlue)" : "", 
                                          transition: "180ms" 
                                        }}
                                      >
                                        Approved Code
                                      </p>
                                    </div>
                                    <input id="approved-code" value={closeEnqDetails.approvedCode} placeholder="Enter Approved Code" onChange={handleChange("approvedCode")} className={`${currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                  </div>
                                </div>
                              )
                            }

                            {
                              closeEnqDetails.paymentMode == "Cheque" && (
                                <div className="w-full">
                                  <div 
                                    onClick={toggleInputFields('cheque-number')} 
                                    className={`${currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} 
                                    style={{ border: currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "1px solid var(--darkBlue)" : "" }}
                                  >
                                    <div className="flex-item d-flex">
                                      <p 
                                        className="placeholder-txt flex-item" 
                                        style={{ 
                                          fontSize: currentElementId === "cheque-number" || closeEnqDetails.chequeNumber ? "10px" : "14px", 
                                          color: currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "var(--darkBlue)" : "", 
                                          transition: "180ms" 
                                        }}
                                      >
                                        Cheque Number
                                      </p>
                                    </div>
                                    <input id="cheque-number" value={closeEnqDetails.chequeNumber} placeholder="Enter Cheque Number" onChange={handleChange("chequeNumber")} className={`${currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                  </div>
                                </div>
                              )
                            }

                            {
                              (closeEnqDetails.paymentSource == "NEFT" || closeEnqDetails.paymentSource == "RTGS" || closeEnqDetails.paymentSource == "IMPS" ) && (
                                <div className="w-full">
                                  <div 
                                    onClick={toggleInputFields('bank-name')} 
                                    className={`${currentElementId == "bank-name" || closeEnqDetails.bankName ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} 
                                    style={{ border: currentElementId == "bank-name" || closeEnqDetails.bankName ? "1px solid var(--darkBlue)" : "" }}
                                  >
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{  fontSize: currentElementId === "bank-name" || closeEnqDetails.bankName ? "10px" : "14px", color: currentElementId == "bank-name" || closeEnqDetails.bankName ? "var(--darkBlue)" : "", transition: "180ms" }}> Bank Name </p>
                                    </div>
                                    <input id="bank-name" value={closeEnqDetails.bankName} placeholder="Enter Bank Name" onChange={handleChange("bankName")} className={`${currentElementId == "bank-name" || closeEnqDetails.bankName ? "active-input-field" : "inactive-input-field"}`} type="text" />

                                  </div>
                                </div>
                              )
                            }

                            
                              {
                                  (closeEnqDetails.paymentSource == "UPI") && (
                                    <div onClick={toggleInputFields('upi-id')}  className={`${currentElementId == "upi-id" || closeEnqDetails.upiId ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`}  style={{ border: currentElementId == "upi-id" || closeEnqDetails.upiId ? "1px solid var(--darkBlue)" : "" }} >
                                      <div className="flex-item d-flex">
                                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "upi-id" || closeEnqDetails.upiId ? "10px" : "14px", color: currentElementId == "upi-id" || closeEnqDetails.upiId ? "var(--darkBlue)" : "", transition: "180ms"  }} >  Aadhaar No./Mobile No. </p>
                                      </div>
                                      <input id="upi-id" value={closeEnqDetails.upiId} placeholder="Enter Aadhaar or Mobile No. or UPI ID" onChange={handleChange("upiId")} className={`${currentElementId == "upi-id" || closeEnqDetails.upiId ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                    </div>
                                  )
                                }
                              
                            

                            {
                              closeEnqDetails.paymentSource == "Paytm" || closeEnqDetails.paymentSource == "PhonePe" || closeEnqDetails.paymentSource == "Google Pay" || closeEnqDetails.paymentSource == "Amazon Pay" && (
                                <div onClick={toggleInputFields('payment-number')} className={`${currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "1px solid var(--darkBlue)" : "" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "payment-number" || closeEnqDetails.paymentNumber ? "10px" : "14px", color: currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment mobile number</p>
                                  </div>
                                  <div className={`${currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                                    <input className="flex-item" id="payment-number" value={closeEnqDetails.paymentNumber} placeholder="Enter payment mobile number" onChange={handleChange("paymentNumber")} style={{width:"100%"}} type="text" />
                                  </div>
                                </div>
                              )
                            }

                            {
                              (closeEnqDetails.paymentSource == "NEFT" || closeEnqDetails.paymentSource == "RTGS" || closeEnqDetails.paymentSource == "IMPS" || closeEnqDetails.paymentSource == "UPI" || closeEnqDetails.paymentSource == "Juice" || closeEnqDetails.paymentSource == "Paytm" || closeEnqDetails.paymentSource == "PhonePe" || closeEnqDetails.paymentSource == "Google Pay" || closeEnqDetails.paymentSource == "Amazon Pay") && (
                               <div onClick={toggleInputFields('transaction-id')}  className={`${currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`}  style={{ border: currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "1px solid var(--darkBlue)" : "" }} >
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "transaction-id" || closeEnqDetails.transactionID ? "10px" : "14px",  color: currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "var(--darkBlue)" : "",  transition: "180ms"  }} > Transaction ID </p>
                                  </div>
                                  <input id="transaction-id" value={closeEnqDetails.transactionID} placeholder="Enter Transaction ID" onChange={handleChange("transactionID")} className={`${currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                </div>
                                
                              )
                            }


                            {
                              closeEnqDetails.paymentMode == "Other" && (
                             <div  onClick={toggleInputFields('comment')} className={`${currentElementId == "comment" || closeEnqDetails.comment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`}  style={{ border: currentElementId == "comment" || closeEnqDetails.comment ? "1px solid var(--darkBlue)" : "" }} >
                                  <div className="flex-item d-flex">
                                    <p  className="placeholder-txt flex-item" style={{  fontSize: currentElementId === "comment" || closeEnqDetails.comment ? "10px" : "14px",  color: currentElementId == "comment" || closeEnqDetails.comment ? "var(--darkBlue)" : "",   transition: "180ms"  }} > Comment * </p>
                                  </div>
                                  <input  id="comment" value={closeEnqDetails.comment}  placeholder="Enter Comment"  onChange={handleChange("comment")} className={`${currentElementId == "comment" || closeEnqDetails.comment ? "active-input-field" : "inactive-input-field"}`} type="text" />
                                </div>
                              )
                            }

                          </div>
                         <div onClick={toggleInputFields('global-comment')} className={`${currentElementId == "global-comment" || closeEnqDetails.globalComment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12 m-t-20`} style={{ border: currentElementId == "global-comment" || closeEnqDetails.globalComment ? "1px solid var(--darkBlue)" : "" }} >
                              <div className="flex-item d-flex">
                                <p  className="placeholder-txt flex-item"  style={{  fontSize: currentElementId === "global-comment" || closeEnqDetails.globalComment ? "10px" : "14px",  color: currentElementId == "global-comment" || closeEnqDetails.globalComment ? "var(--darkBlue)" : "",   transition: "180ms"  }} >  Close Enquiry Comment </p>
                              </div>
                              <input  id="global-comment"  value={closeEnqDetails.globalComment}  placeholder="Enter Enquiry Comment"  onChange={handleChange("globalComment")}  className={`${currentElementId == "global-comment" || closeEnqDetails.globalComment ? "active-input-field" : "inactive-input-field"}`} type="text" />
                            </div>
                        </div>

                        {
                          window.innerWidth < 768 && (
                            <svg className="m-t-16 m-b-12" width="100%" height="2" viewBox="0 0 376 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <line x1="-0.00195312" y1="0.5" x2="376.001" y2="0.5" stroke="#BDBDBD" stroke-dasharray="4 4"/>
                            </svg>
                          )
                        }

                        {/* BILLING */}
                        <div style={{width: window.innerWidth > 767 ? "48%" : "100%"}}>
                          <div className="w-full d-flex">
                            <p className={`${window.innerWidth < 768 ? "margin-auto fs-16" : "fs-18 m-b-20"} font-weight-700 color-dark-blue`} style={{marginBottom: window.innerWidth < 768 && "12px"}}>Billing Summary</p>
                          </div>
                          <div className="billing-container bg-white">
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">Selected Plans Total</p>
                              <p className="flex-item font-weight-700 color-grey-02">₹ {billingInfo.selectedPlansPrice}</p>
                            </div>
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">Pool Charges</p>
                              <p className="flex-item font-weight-700 color-grey-02">+ ₹ {billingInfo.poolCharge}</p>
                            </div>
                            {
                              props.type == "upgrade-membership" && (
                                <div className="d-flex space-between m-b-8">
                                  <p className="flex-item color-grey-04">Prorated Credit</p>
                                  <p className="flex-item font-weight-700 color-green">- ₹ {amountPaid}</p>
                                </div>
                              )
                            }
                            {billingInfo.GstOnPaidAmount ? (
                                parseFloat(closeEnqDetails.amountPaid || 0) > 0 && (
                                  <div className="d-flex space-between m-b-12">
                                    <p className="flex-item color-grey-04">Total Discount</p>
                                    <input className="flex-item" value={closeEnqDetails.paidDiscount} onInput={handleChange("paidDiscount")} placeholder="₹ 0.0" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#0088DA", textAlign:"center", fontWeight:"700"}} type="number" />
                                  </div>
                                )
                              ) :(
                            <div className="d-flex space-between m-b-12">
                              <p className="flex-item color-grey-04">Total Discount</p>
                              <p className="flex-item font-weight-700 color-green">- ₹ {billingInfo.selectedPlansDiscount}</p>
                            </div>
                            )
                            }
                            <div className="d-flex space-between flex-item m-b-20">
                              <div className="flex-item d-flex">
                                <input onClick={applyGSTPaidAmount} checked={billingInfo.GstOnPaidAmount} className="flex-item m-r-6" type="checkbox" style={{width:"auto"}}/>
                                <p className="flex-item font-weight-700">GST On Paid Amount</p>
                              </div>
                              {
                                billingInfo.GstOnPaidAmount && (
                                  <div className="d-flex">
                                    <p className="flex-item font-weight-700 color-red m-r-8">₹ </p>
                                    <input className="flex-item" value={closeEnqDetails.amountPaid} onInput={handleChange("amountPaid")} placeholder="0.0" style={{border:"1px solid #e33a34", borderRadius:'4px', width:"80px", height:"30px", color:"#e33a34", textAlign:"center", fontWeight:"700"}} type="number" />
                                  </div>
                                )
                              }
                            </div>
                            <div className="d-flex m-b-8">
                              <div className="d-flex flex-item">
                                <input onClick={applyInclusive} checked={taxType == "inclusive-tax"} className="flex-item m-r-6" type="checkbox" style={{width:"auto"}}/>
                                <p className="flex-item font-weight-700">Inclusive Tax</p>
                              </div>
                              <div className="d-flex flex-item m-l-16">
                                <input onClick={applyTaxes} checked={taxType == "additional-tax"} className="flex-item m-r-6" type="checkbox" style={{width:"auto"}}/>
                                <p className="flex-item font-weight-700">Additional Taxes</p>
                              </div>
                            </div>
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">{billingInfo.GstOnPaidAmount == true ? "Gross Amount" : "Taxable Amount"}</p>
                              <p className="flex-item font-weight-700 color-grey-02">₹ {parseFloat(billingInfo.taxableAmount)}</p>
                            </div>

                            {
                              taxType && <>
                              {
                                billingInfo.taxBreakup.map(tax=>{
                                  return (
                                    <div className="d-flex space-between m-b-8">
                                      <p className="flex-item color-grey-04">{tax.name} ( {tax.value} % )</p>
                                      <p className="flex-item font-weight-700 color-red">+ ₹ {tax.amount}</p>
                                    </div>
                                  )
                                })
                              }
                              </>
                            }
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">Sub Total</p>
                              {
                                isEditBillingInfoSubTotal ? (
                                  <div className="flex-item d-flex cursor-pointer">
                                    <div onClick={()=>toggleEditBillingInfo()} className="flex-item d-flex cursor-pointer" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                      <svg className="flex-item margin-auto" width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 14L14 1M14 14L1 1" stroke="#E33A34" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </div>
                                    <div onClick={()=>toggleEditBillingInfo("check")} className="flex-item d-flex cursor-pointer m-l-12" style={{width:"30px", height:"30px", borderRadius:'100%', boxShadow:"0px 0px 4px rgba(0,0,0,0.35)"}}>
                                      <svg className="flex-item margin-auto" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 6.08696L4.48387 10L13 1" stroke="#03AA00" stroke-width="2" stroke-linecap="round"/>
                                      </svg>
                                    </div>
                                    <input className="flex-item m-l-12" value={editableSubTotal} onChange={handleChange("editable-subtotal")} placeholder="₹ 0.0" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#5d883c", textAlign:"center", fontWeight:"700"}} type="number" />
                                  </div>
                                ) : (
                                  <div onClick={()=>billingInfo.taxableAmount > 0 && closeEnqDetails.selectedMemberships.length == 1 && !billingInfo.GstOnPaidAmount && toggleEditBillingInfo()} className="d-flex cursor-pointer" style={{border:billingInfo.taxableAmount > 0 && "1px solid #9a9a9a", padding: billingInfo.taxableAmount > 0 && "6px 7px", borderRadius:"4px"}}>
                                    <p className="flex-item font-weight-700 color-grey-02">₹ {billingInfo.subTotal}</p>
                                    {
                                      billingInfo.taxableAmount > 0 && closeEnqDetails.selectedMemberships.length == 1 && !billingInfo.GstOnPaidAmount && (
                                        <svg className="flex-item m-l-12" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M15.1819 0.818331C14.6578 0.294358 13.9471 0 13.206 0C12.4649 0 11.7541 0.294358 11.23 0.818331L1.34722 10.7023C1.05902 10.9903 0.860168 11.3555 0.774589 11.7538L0.0127902 15.3083C-0.00729956 15.4017 -0.00367601 15.4986 0.0233298 15.5901C0.0503356 15.6817 0.0998627 15.7651 0.167386 15.8326C0.23491 15.9001 0.318277 15.9497 0.409871 15.9767C0.501466 16.0037 0.598368 16.0073 0.691723 15.9872L4.24641 15.2255C4.64477 15.1399 5.00993 14.941 5.29795 14.6528L15.1819 4.76942C15.7057 4.24539 16 3.5348 16 2.79387C16 2.05295 15.7057 1.34236 15.1819 0.818331ZM12.0387 1.62638C12.3512 1.33088 12.7666 1.16892 13.1967 1.17495C13.6267 1.18097 14.0375 1.35451 14.3415 1.65865C14.6456 1.96279 14.8191 2.37354 14.825 2.80357C14.8309 3.2336 14.6688 3.64897 14.3732 3.96137L13.8589 4.47569L11.5238 2.14126L12.0387 1.62638ZM10.7151 2.94931L13.0502 5.2843L4.49043 13.8454C4.35798 13.9778 4.19008 14.069 4.00695 14.1082L1.31465 14.6854L1.89186 11.9938C1.93105 11.8107 2.02235 11.6428 2.15474 11.5104L10.7151 2.94931Z" fill="var(--darkBlue)"/>
                                        </svg>
                                      )
                                    }
                                  </div>
                                )
                              }
                            </div>
                            <div className="d-flex space-between m-b-12">
                              <p className="flex-item color-grey-04">Surcharges (%)</p>
                              <input className="flex-item" value={closeEnqDetails.surCharges} onInput={handleChange("surCharges")} placeholder="0 %" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#0088DA", textAlign:"center", fontWeight:"700"}} type="number" max={100} min={1} />
                            </div>
                            <svg className="flex-item m-b-12" width="100%" height="2" viewBox="0 0 360 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <line y1="1" x2="360" y2="1" stroke="#B4B4B4" stroke-dasharray="2 2"/>
                            </svg>
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">Payable Amount</p>
                              <p className="flex-item font-weight-700 color-green">₹ {billingInfo.payableAmount}</p>
                            </div>
                            <div className="d-flex space-between m-b-8">
                              <p className="flex-item color-grey-04">Amount Paid</p>
                              {
                                billingInfo.GstOnPaidAmount ? (
                                  <p className="flex-item font-weight-700 color-red">₹ {billingInfo.payableAmount}</p>
                                ) : (
                                  <input className="flex-item" value={closeEnqDetails.amountPaid} onInput={handleChange("amountPaid")} placeholder="₹ 0.0" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#0088DA", textAlign:"center", fontWeight:"700"}} type="number" />
                                )
                              }
                            </div>
                            <div className="d-flex space-between">
                              <p className="flex-item color-grey-04">Remaining Amount</p>
                              <p className="flex-item font-weight-700 color-red">₹ {billingInfo.remainingAmount}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {
                        isRemainingAmountDue ? (
                          <div className="bottom-action-button">
                            <div className="balance-due-alert-container">
                              <div className="d-flex">
                                <p className="fs-20 color-black font-weight-600 margin-auto">Remaining Amount</p>
                              </div>
                              <div className="d-flex m-t-16">
                                <p className="fs-34 color-red font-weight-800 margin-auto">₹ {billingInfo.remainingAmount}</p>
                              </div>
                              <div className="d-flex m-t-24">
                                <div onClick={toggleInputFields('payment-due-date')} className={`${currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} margin-auto`} style={{ border: currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "1px solid var(--darkBlue)" : "", width:"40%" }}>
                                  <div className="flex-item d-flex w-full">
                                    <p className="placeholder-txt flex-item margin-auto" style={{ fontSize: currentElementId === "payment-due-date" || closeEnqDetails.paymentDueDate ? "10px" : "14px", color: currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment Due Date <span className="color-red">*</span></p>
                                  </div>
                                  <div className={`${currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "active-input-field" : "inactive-input-field"} d-flex flex-item m-t-22`} style={{width:"92%"}}>
                                    <input className="flex-item" id="payment-due-date" value={formatDateTime(closeEnqDetails.paymentDueDate)} placeholder="DD/MM/YYYY" style={{width:"100%", textAlign:"center", marginTop: window.innerWidth < 768 ? "17px" : undefined}} type="text" />
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex m-t-30">
                                <p className="margin-auto color-red fs-18 font-weight-700">Are you sure you want to close this enquiry ?</p>
                              </div>
                              <div className="d-flex m-t-12">
                                <div className="flex-item d-flex margin-auto" style={{ gap: "20px" }}>
                                  <div onClick={cancelCloseEnquiry} className="flex-item d-flex member-button-global m-r-12">
                                    <p className="flex-item">No</p>
                                  </div>
                                  {/* <div
                                    onClick={() => (isButtonLock || isDueDateMissing) ? null : CloseEnquiry()}
                                    className={`flex-item d-flex member-button-global ${(isButtonLock || isDueDateMissing) ? 'global-blue-button-controller-inactive' : 'global-blue-button-controller-active'}`}
                                  >
                                    <p className="flex-item">Yes</p>
                                  </div> */}
                                  <div
                                    onClick={() => isButtonLock ? null : CloseEnquiry()}
                                    className={`flex-item d-flex member-button-global ${(isButtonLock || isDueDateMissing) ? 'global-blue-button-controller-inactive' : 'global-blue-button-controller-active'}`}
                                  >
                                    <p className="flex-item">Yes</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        ) : (
                          <div className="bottom-action-button">
                            <div onClick={isButtonLock?null:checkAndCloseEnquiry} className={`member-button-global btn-center d-flex ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"}`} style={{ width: "100%", height:"40px", borderRadius:"20px" }}>
                              <p className="flex-item">Submit</p>
                            </div>
                          </div>
                        )
                      }

                    </div>
                  ]
                }


              </div>
            </div>
          )
        }


      </div>
    </div>
  )
}

export default MembershipBillingController;